const RouterList = [
    {
        path: '/employee/index',
        component: (callback) => {
            import('./../viewport/manager/employee/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/employee/index'
    }
    ,
    {
        path: '/employee/edit/index',
        component: (callback) => {
            import('./../viewport/user/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/employee/edit/index'
    }
    ,
    {
        path: '/employee/pwd/index',
        component: (callback) => {
            import('./../viewport/user/UpdatePwd').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/employee/pwd/index'
    }
    ,
    {
        path: '/employee/insert',
        component: (callback) => {
            import('./../viewport/manager/employee/Insert').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/employee/insert'
    }
    ,
    {
        path: '/employee/update/:id',
        component: (callback) => {
            import('./../viewport/manager/employee/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/employee/update/'
    }
    ,
    {
        path: '/student/index',
        component: (callback) => {
            import('./../viewport/manager/student/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/student/index'
    }
    ,
    {
        path: '/student/insert',
        component: (callback) => {
            import('./../viewport/manager/student/Insert').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/student/insert'
    }
    ,
    {
        path: '/student/update/:id',
        component: (callback) => {
            import('./../viewport/manager/student/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/student/update/'
    }
    ,
    {
        path: '/classes/index',
        component: (callback) => {
            import('./../viewport/manager/classes/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/classes/index'
    }
    ,
    {
        path: '/classes/indexbytype/:classType',
        component: (callback) => {
            import('./../viewport/manager/classes/QueryByType').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/classes/indexbytype/'
    }
    ,
    {
        path: '/classes/insert',
        component: (callback) => {
            import('./../viewport/manager/classes/Insert').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/classes/insert'
    }
    ,
    {
        path: '/classes/update/:id',
        component: (callback) => {
            import('./../viewport/manager/classes/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/classes/update/'
    }
    ,
    {
        path: '/course/index',
        component: (callback) => {
            import('./../viewport/manager/course/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/course/index'
    }
    ,
    {
        path: '/course/insert',
        component: (callback) => {
            import('./../viewport/manager/course/Insert').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/course/insert'
    }
    ,
    {
        path: '/course/update/:id',
        component: (callback) => {
            import('./../viewport/manager/course/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/course/update/'
    }
    ,
    {
        path: '/org/index',
        component: (callback) => {
            import('./../viewport/manager/org/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/org/index'
    }
    ,
    {
        path: '/majorgroup/index',
        component: (callback) => {
            import('./../viewport/manager/majorgroup/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/majorgroup/index'
    }
    ,
    {
        path: '/major/index',
        component: (callback) => {
            import('./../viewport/manager/major/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/major/index'
    }
    ,
    {
        path: '/syscode/index',
        component: (callback) => {
            import('./../viewport/systems/syscode/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/syscode/index'
    }
    ,
    {
        path: '/sysmodule/index',
        component: (callback) => {
            import('./../viewport/systems/sysmodule/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/sysmodule/index'
    }
    ,
    {
        path: '/sysparam/index',
        component: (callback) => {
            import('./../viewport/systems/sysparam/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/sysparam/index'
    }
    ,
    {
        path: '/sysparam/insert',
        component: (callback) => {
            import('./../viewport/systems/sysparam/Insert').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/sysparam/insert'
    }
    ,
    {
        path: '/sysparam/update/:id',
        component: (callback) => {
            import('./../viewport/systems/sysparam/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/sysparam/update/'
    }
    ,
    {
        path: '/log/index',
        component: (callback) => {
            import('./../viewport/systems/logger/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/log/index'
    }
    ,
    {
        path: '/role/index',
        component: (callback) => {
            import('./../viewport/systems/roles/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/role/index'
    }
    ,
    {
        path: '/role/insert',
        component: (callback) => {
            import('./../viewport/systems/roles/Insert').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/role/insert'
    }
    ,
    {
        path: '/role/update/:id',
        component: (callback) => {
            import('./../viewport/systems/roles/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/role/update/'
    }
    ,
    {
        path: '/term/index',
        component: (callback) => {
            import('./../viewport/systems/term/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/term/index'
    }
    ,
    {
        path: '/term/insert',
        component: (callback) => {
            import('./../viewport/systems/term/Insert').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/term/insert'
    }
    ,
    {
        path: '/term/update/:id',
        component: (callback) => {
            import('./../viewport/systems/term/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/term/update/'
    }
    ,
    {
        path: '/evaltarget/index',
        component: (callback) => {
            import('./../viewport/indexes/evals/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evaltarget/index'
    }
    ,
    {
        path: '/evalitem/index',
        component: (callback) => {
            import('./../viewport/indexes/items/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalitem/index'
    }
    ,
    {
        path: '/eval/result/list/:itemId',
        component: (callback) => {
            import('./../viewport/reports/list/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/list/'
    }
    ,
    {
        path: '/eval/result/log/:targetId',
        component: (callback) => {
            import('./../viewport/reports/list/Log').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/log/'
    }
    ,
    {
        path: '/eval/result/totalByDate/:itemId',
        component: (callback) => {
            import('./../viewport/reports/totalDate/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/totalByDate/'
    }
    ,
    {
        path: '/eval/result/readonly/list/:itemId/:readonly',
        component: (callback) => {
            import('./../viewport/reports/list/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/readonly/list/'
    },
    {
        path: '/eval/result/readonly/submitedlist/:itemId/:readonly',
        component: (callback) => {
            import('./../viewport/reports/list/QuerySubmited').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/readonly/submitedlist/'
    }
    ,
    {
        path: '/eval/result/decimal/list/:decimal/:itemId',
        component: (callback) => {
            import('./../viewport/reports/list/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/decimal/list/'
    }
    ,
    {
        path: '/eval/result/decimal/readonly/list/:decimal/:itemId/:readonly',
        component: (callback) => {
            import('./../viewport/reports/list/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/decimal/readonly/list/'
    }
    ,
    {
        path: '/eval/result/listcomments/:itemId',
        component: (callback) => {
            import('./../viewport/reports/comments/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/listcomments/'
    }
    ,
    {
        path: '/eval/result/listtotal/:itemId',
        component: (callback) => {
            import('./../viewport/reports/total/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/listtotal/'
    }
    ,
    {
        path: '/eval/result/listtotalbyemporg/:itemId',
        component: (callback) => {
            import('./../viewport/reports/totalEmpOrg/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/listtotalbyemporg/'
    }
    ,
    {
        path: '/eval/result/listtotalbyterm/:itemId',
        component: (callback) => {
            import('./../viewport/reports/term/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/listtotalbyterm/'
    }
    ,
    {
        path: '/eval/result/readonly/listtotalbyterm/:itemId/:readonly',
        component: (callback) => {
            import('./../viewport/reports/term/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/readonly/listtotalbyterm/'
    }
    ,
    {
        path: '/eval/result/commentbyterm/:itemId/:id',
        component: (callback) => {
            import('./../viewport/reports/term/Comment').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/commentbyterm/'
    }
    ,
    {
        path: '/eval/result/listtotalbyyear/:itemId',
        component: (callback) => {
            import('./../viewport/reports/year/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/listtotalbyyear/'
    }
    ,
    {
        path: '/eval/result/readonly/listtotalbyyear/:itemId/:readonly',
        component: (callback) => {
            import('./../viewport/reports/year/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/readonly/listtotalbyyear/'
    }
    ,
    {
        path: '/eval/result/commentbyyear/:itemId/:id',
        component: (callback) => {
            import('./../viewport/reports/year/Comment').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/commentbyyear/'
    }
    ,
    {
        path: '/eval/result/listall/:itemId',
        component: (callback) => {
            import('./../viewport/reports/listAll/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/listall/'
    }
    ,
    {
        path: '/course/plan/index',
        component: (callback) => {
            import('./../viewport/plans/course/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/course/plan/index'
    }
    ,
    {
        path: '/course/planspecial/import',
        component: (callback) => {
            import('./../viewport/plans/courseExImport/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/course/planspecial/import'
    }
    ,
    {
        path: '/course/planspecial/index',
        component: (callback) => {
            import('./../viewport/plans/courseEx/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/course/planspecial/index'
    }
    ,
    {
        path: '/course/plan/insert/:orgId',
        component: (callback) => {
            import('./../viewport/plans/course/Insert').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/course/plan/insert/'
    }
    ,
    {
        path: '/course/plan/update/:id',
        component: (callback) => {
            import('./../viewport/plans/course/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/course/plan/update/'
    }
    ,
    {
        path: '/listen/org/index/:type',
        component: (callback) => {
            import('./../viewport/plans/listen/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/listen/org/index/'
    }
    ,
    {
        path: '/student/role/index',
        component: (callback) => {
            import('./../viewport/systems/studentRoles/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/student/role/index'
    }
    ,
    {
        path: '/student/pwd/index',
        component: (callback) => {
            import('./../viewport/user/StuUpdatePwd').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/student/pwd/index'
    }
    ,
    {
        path: '/listen/org/import/index',
        component: (callback) => {
            import('./../viewport/plans/listenOrgImport/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/listen/org/import/index'
    }
    ,
    {
        path: '/listenmanager/assgin',
        component: (callback) => {
            import('./../viewport/plans/listenManager/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/listenmanager/assgin'
    }
    ,
    {
        path: '/listenmanager/generate/:type',
        component: (callback) => {
            import('./../viewport/plans/listenManagerGenerate/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/listenmanager/generate/'
    }
    ,
    {
        path: '/listenmanager/generateSelf/index',
        component: (callback) => {
            import('./../viewport/plans/listenManagerGenerateSelf/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/listenmanager/generateSelf/index'
    }
    ,
    {
        path: '/listenmanager/publish/:type/:orgId',
        component: (callback) => {
            import('./../viewport/plans/listenManagerPublish/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/listenmanager/publish/'
    }
    ,
    {
        path: '/listenmanager/entrylist',
        component: (callback) => {
            import('./../viewport/plans/listenManagerEntryList/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/listenmanager/entrylist'
    }
    ,
    {
        path: '/listenmanager/entryListByType/:listenType',
        component: (callback) => {
            import('./../viewport/plans/listenManagerEntryList/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/listenmanager/entryListByType/'
    }
    ,
    {
        path: '/listenmanager/inputs/:itemId/:itemPid/:id/:courseName/:planId',
        component: (callback) => {
            import('./../viewport/plans/listenManagerInputs/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/listenmanager/inputs/'
    }
    ,
    {
        path: '/listenmanager/listenmanagerview',
        component: (callback) => {
            import('./../viewport/plans/listenManagerView/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/listenmanager/listenmanagerview'
    }
    ,
    {
        path: '/listenmanager/listenmanagerevallist',
        component: (callback) => {
            import('./../viewport/plans/listenManagerEvalList/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/listenmanager/listenmanagerevallist'
    }
    ,
    {
        path: '/listenmanager/evalinputs/:itemId/:itemPid/:planId',
        component: (callback) => {
            import('./../viewport/plans/listenManagerEvalInputs/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/listenmanager/evalinputs/'
    }
    ,
    {
        path: '/listenmanager/listenmanagercustomized',
        component: (callback) => {
            import('./../viewport/plans/listenManagerCustomized/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/listenmanager/listenmanagercustomized'
    }
    ,
    {
        path: '/listenmanager/listenmanagermonitor',
        component: (callback) => {
            import('./../viewport/plans/listenManagerMonitor/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/listenmanager/listenmanagermonitor'
    }
    ,
    {
        path: '/listenmanager/sendmessagelist',
        component: (callback) => {
            import('./../viewport/message/report/view/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/listenmanager/sendmessagelist'
    }
    ,
    {
        path: '/listenmanager/listenedmanagermonitor',
        component: (callback) => {
            import('./../viewport/plans/listenedManagerMonitor/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/listenmanager/listenedmanagermonitor'
    }
    ,
    {
        path: '/listenmanager/listenmanagermonitornew',
        component: (callback) => {
            import('./../viewport/plans/listenManagerMonitorNew/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/listenmanager/listenmanagermonitornew'
    }
    ,
    {
        path: '/listenmanager/listenweightresultlist',
        component: (callback) => {
            import('./../viewport/plans/listenWeightResultList/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/listenmanager/listenweightresultlist'
    }
    ,
    {
        path: '/listenmanager/listenweightresulttotal',
        component: (callback) => {
            import('./../viewport/plans/listenWeightResultTotal/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/listenmanager/listenweightresulttotal'
    }
    ,
    {
        path: '/listenManager/plan/import/index',
        component: (callback) => {
            import('./../viewport/plans/listenPlanImport/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/listenManager/plan/import/index'
    }
    ,
    {
        path: '/file/index/:folderId',
        component: (callback) => {
            import('./../viewport/diagnosis/file/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/file/index/'
    }
    ,
    {
        path: '/file/manage/index',
        component: (callback) => {
            import('./../viewport/diagnosis/manage/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/file/manage/index'
    }
    ,
    {
        path: '/evalscore/index/:itemId/:itemPid/',
        component: (callback) => {
            import('./../viewport/score/inputs/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalscore/index/'
    }
    ,
    {
        path: '/evalscore/decimal/index/:decimal/:itemId/:itemPid/',
        component: (callback) => {
            import('./../viewport/score/inputs/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalscore/decimal/index/'
    }
    ,
    {
        path: '/evalscore/detail/:id/:readonly/:listId',
        component: (callback) => {
            import('./../viewport/score/detail/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalscore/detail/'
    }
    ,
    {
        path: '/evalscore/decimal/detail/:decimal/:id/:readonly/:listId',
        component: (callback) => {
            import('./../viewport/score/detail/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalscore/decimal/detail/'
    }
    ,
    {
        path: '/folder/index',
        component: (callback) => {
            import('./../viewport/manager/folder/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/folder/index'
    }
    ,
    {
        path: '/folder/auth/index',
        component: (callback) => {
            import('./../viewport/manager/auth/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/folder/auth/index'
    }
    ,
    {
        path: '/plan/courseplanstudent/index',
        component: (callback) => {
            import('./../viewport/mobile/plan/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/plan/courseplanstudent/index'
    }
    ,
    {
        path: '/plan/courseplanstudent/insert',
        component: (callback) => {
            import('./../viewport/mobile/plan/Insert').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/plan/courseplanstudent/insert'
    }
    ,
    {
        path: '/plan/courseplanstudent/update/:id',
        component: (callback) => {
            import('./../viewport/mobile/plan/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/plan/courseplanstudent/update/'
    }
    ,
    {
        path: '/plan/courseplanstudent/publish',
        component: (callback) => {
            import('./../viewport/mobile/plan/Publish').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/plan/courseplanstudent/publish'
    }
    ,
    {
        path: '/updateplan/courseplanstudent/index',
        component: (callback) => {
            import('./../viewport/mobile/updateplan/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/updateplan/courseplanstudent/index'
    }
    ,
    {
        path: '/updateplan/courseplanstudent/insert',
        component: (callback) => {
            import('./../viewport/mobile/updateplan/Insert').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/updateplan/courseplanstudent/insert'
    }
    ,
    {
        path: '/updateplan/courseplanstudent/update/:id',
        component: (callback) => {
            import('./../viewport/mobile/updateplan/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/updateplan/courseplanstudent/update/'
    }
    ,
    {
        path: '/plan/courseplansimple/index',
        component: (callback) => {
            import('./../viewport/mobile/course/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/plan/courseplansimple/index'
    }
    ,
    {
        path: '/plan/courseplansimple/update/:id',
        component: (callback) => {
            import('./../viewport/mobile/course/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/plan/courseplansimple/update/'
    }
    ,
    {
        path: '/plan/courseplansimple/publish',
        component: (callback) => {
            import('./../viewport/mobile/course/Publish').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/plan/courseplansimple/publish'
    }
    ,
    {
        path: '/studentcourse/index',
        component: (callback) => {
            import('./../viewport/mobile/student/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/studentcourse/index'
    },
    {
        path: '/studentcourse/telmessage/index',
        component: (callback) => {
            import('./../viewport/mobile/telmessage/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/studentcourse/telmessage/index'
    }
    ,
    {
        path: '/studentcourse/QueryOnly/index',
        component: (callback) => {
            import('./../viewport/mobile/student/QueryOnly').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/studentcourse/QueryOnly/index'
    }
    ,
    {
        path: '/studentcourse/insert',
        component: (callback) => {
            import('./../viewport/mobile/student/Insert').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/studentcourse/insert'
    }
    ,
    {
        path: '/teachercourse/index',
        component: (callback) => {
            import('./../viewport/mobile/employee/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teachercourse/index'
    }
    ,
    {
        path: '/studentchat/index',
        component: (callback) => {
            import('./../viewport/mobile/chat/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/studentchat/index'
    }
    ,
    {
        path: '/survey/index',
        component: (callback) => {
            import('./../viewport/mobile/survey/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/survey/index'
    }
    ,
    {
        path: '/survey/detail/:id',
        component: (callback) => {
            import('./../viewport/mobile/survey/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/survey/detail/'
    }
    ,
    {
        path: '/muleval/listtotalbyempterm/index',
        component: (callback) => {
            import('./../viewport/muleval/empterm/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/muleval/listtotalbyempterm/index'
    }
    ,
    {
        path: '/muleval/listtotalbyempterm/readonly/index/:readonly',
        component: (callback) => {
            import('./../viewport/muleval/empterm/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/muleval/listtotalbyempterm/readonly/index/'
    }
    ,
    {
        path: '/muleval/listtotalbyempterm/update/:id',
        component: (callback) => {
            import('./../viewport/muleval/empterm/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/muleval/listtotalbyempterm/update/'
    }
    ,
    {
        path: '/muleval/listtotalbyempyear/index',
        component: (callback) => {
            import('./../viewport/muleval/empyear/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/muleval/listtotalbyempyear/index'
    }
    ,
    {
        path: '/muleval/listtotalbyempyearssti/index',
        component: (callback) => {
            import('./../viewport/muleval/empyearssti/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/muleval/listtotalbyempyearssti/index'
    }
    ,
    {
        path: '/muleval/listtotalbyempyearssti2/:employeeProperty',
        component: (callback) => {
            import('./../viewport/muleval/empyearssti2/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/muleval/listtotalbyempyearssti2'
    }
    ,
    {
        path: '/muleval/listtotalbyempyear/readonly/index/:readonly',
        component: (callback) => {
            import('./../viewport/muleval/empyear/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/muleval/listtotalbyempyear/readonly/index/'
    }
    ,
    {
        path: '/muleval/listtotalbyempyear/update/:id',
        component: (callback) => {
            import('./../viewport/muleval/empterm/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/muleval/listtotalbyempyear/update/'
    }
    ,
    {
        path: '/muleval/listtotalbyorgterm/index',
        component: (callback) => {
            import('./../viewport/muleval/orgterm/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/muleval/listtotalbyorgterm/index'
    }
    ,
    {
        path: '/muleval/listtotalbyorgterm/readonly/index/:readonly',
        component: (callback) => {
            import('./../viewport/muleval/orgterm/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/muleval/listtotalbyorgterm/readonly/index/'
    }
    ,
    {
        path: '/muleval/listtotalbyorgyear/index',
        component: (callback) => {
            import('./../viewport/muleval/orgyear/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/muleval/listtotalbyorgyear/index'
    }
    ,
    {
        path: '/muleval/listtotalbyorgyear/readonly/index/:readonly',
        component: (callback) => {
            import('./../viewport/muleval/orgyear/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/muleval/listtotalbyorgyear/readonly/index/'
    }
    ,
    {
        path: '/muleval/listtotalbyemptermex/index',
        component: (callback) => {
            import('./../viewport/muleval/emptermEx/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/muleval/listtotalbyemptermex/index'
    }
    ,
    {
        path: '/muleval/listtotalbyemptermex/readonly/index/:readonly',
        component: (callback) => {
            import('./../viewport/muleval/emptermEx/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/muleval/listtotalbyemptermex/readonly/index/'
    }
    ,
    {
        path: '/muleval/listtotalbyempcourseterm/index',
        component: (callback) => {
            import('./../viewport/muleval/empcourseterm/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/muleval/listtotalbyempcourseterm/index'
    }
    ,
    {
        path: '/muleval/listtotalbyemptermtime/index',
        component: (callback) => {
            import('./../viewport/muleval/emptermbytime/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/muleval/listtotalbyemptermtime/index'
    }
    ,
    {
        path: '/muleval/listtotalbyemptermtimeAll2/index',
        component: (callback) => {
            import('./../viewport/muleval/emptermbytime2/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/muleval/listtotalbyemptermtimeAll2/index'
    }
    ,
    {
        path: '/muleval/listtotalbyemptermtime2/index/:id',
        component: (callback) => {
            import('./../viewport/muleval/emptermbytime2/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/muleval/listtotalbyemptermtime2/index'
    }
    ,
    {
        path: '/muleval/listtotalbyempcourseterm/readonly/index/:readonly',
        component: (callback) => {
            import('./../viewport/muleval/empcourseterm/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/muleval/listtotalbyempcourseterm/readonly/index/'
    }
    ,
    {
        path: '/studentleader/list',
        component: (callback) => {
            import('./../viewport/leader/student/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/studentleader/list'
    }
    ,
    {
        path: '/studentleader/insert',
        component: (callback) => {
            import('./../viewport/leader/student/Insert').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/studentleader/insert'
    }
    ,
    {
        path: '/studentleader/update/:id',
        component: (callback) => {
            import('./../viewport/leader/student/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/studentleader/update/'
    }
    ,
    {
        path: '/studentleader/taskassign',
        component: (callback) => {
            import('./../viewport/leader/task/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/studentleader/taskassign'
    }
    ,
    {
        path: '/analysis/targetanalysisbyorg/index',
        component: (callback) => {
            import('./../viewport/analysis/targetAnalysisByOrg/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/targetanalysisbyorg/index'
    }
    ,
    {
        path: '/analysis/targetanalysisbyteacher/index',
        component: (callback) => {
            import('./../viewport/analysis/targetAnalysisByTeacher/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/targetanalysisbyteacher/index'
    }
    ,
    {
        path: '/analysis/targetanalysisbytarget/index',
        component: (callback) => {
            import('./../viewport/analysis/targetAnalysisByTarget/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/targetanalysisbytarget/index'
    }
    ,
    {
        path: '/analysis/targetanalysisbyterm/index',
        component: (callback) => {
            import('./../viewport/analysis/targetAnalysisByTerm/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/targetanalysisbyterm/index'
    }
    ,
    {
        path: '/analysis/targetandorganalysisbytermoryear/index',
        component: (callback) => {
            import('./../viewport/analysis/targetAndOrgAnalysisByTermOrYear/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/targetandorganalysisbytermoryear/index'
    }
    ,
    {
        path: '/analysis/targetanalysisdifforg/index',
        component: (callback) => {
            import('./../viewport/analysis/targetAnalysisDiffOrg/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/targetanalysisdifforg/index'
    }
    ,
    {
        path: '/analysis/targetanalysisdiffteacher/index',
        component: (callback) => {
            import('./../viewport/analysis/targetAnalysisDiffTeacher/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/targetanalysisdiffteacher/index'
    }
    ,
    {
        path: '/analysis/targetanalysisbyoptions/index',
        component: (callback) => {
            import('./../viewport/analysis/targetAnalysisByOptions/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/targetanalysisbyoptions/index'
    }
    ,
    {
        path: '/analysis/targetanalysisbyquestions/index',
        component: (callback) => {
            import('./../viewport/analysis/targetAnalysisByQuestions/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/targetanalysisbyquestions/index'
    }
    ,
    {
        path: '/analysis/earlywarningbyorg/index',
        component: (callback) => {
            import('./../viewport/analysis/earlyWarningByOrg/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/earlywarningbyorg/index'
    }
    ,
    {
        path: '/analysis/earlywarningbystudentItemId/index/:itemId',
        component: (callback) => {
            import('./../viewport/analysis/earlyWarningByStudent/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/earlywarningbystudentItemId/index'
    }
    ,
    {
        path: '/analysis/earlywarningbystudent/index',
        component: (callback) => {
            import('./../viewport/analysis/earlyWarningByStudent/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/earlywarningbystudent/index'
    }
    ,
    {
        path: '/analysis/earlywarningbycourseItemId/index/:itemId',
        component: (callback) => {
            import('./../viewport/analysis/earlyWarningByCourse/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/earlywarningbycourseItemId/index'
    }
    ,
    {
        path: '/analysis/earlywarningbycourse/index',
        component: (callback) => {
            import('./../viewport/analysis/earlyWarningByCourse/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/earlywarningbycourse/index'
    }
    ,
    {
        path: '/analysis/customizetarget/index',
        component: (callback) => {
            import('./../viewport/analysis/customizeTarget/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/customizetarget/index'
    }
    ,
    {
        path: '/analysis/multipletargetanalysis/index',
        component: (callback) => {
            import('./../viewport/analysis/multipleTargetAnalysis/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/multipletargetanalysis/index'
    }
    ,
    {
        path: '/analysis/keywordanalysis/index',
        component: (callback) => {
            import('./../viewport/analysis/keywordAnalysis/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/keywordanalysis/index'
    }
    ,
    {
        path: '/analysis/keywordquestionanalysis/index',
        component: (callback) => {
            import('./../viewport/analysis/keywordQuestionAnalysis/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/keywordquestionanalysis/index'
    }
    ,
    {
        path: '/analysis/targetandorganalysis/index',
        component: (callback) => {
            import('./../viewport/analysis/targetAndOrgAnalysis/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/targetandorganalysis/index'
    }
    ,
    {
        path: '/sys/init/index',
        component: (callback) => {
            import('./../viewport/sysinit/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/sys/init/index'
    }
    ,
    {
        path: '/evalresultimport/index',
        component: (callback) => {
            import('./../viewport/evalResultImport/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalresultimport/index'
    }
    ,
    {
        path: '/resultimport/index',
        component: (callback) => {
            import('./../viewport/resultImport/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/resultimport/index'
    }
    ,
    {
        path: '/evaltargetimport/index',
        component: (callback) => {
            import('./../viewport/evalTargetImport/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evaltargetimport/index'
    }
    ,
    {
        path: '/studentleaderimport/index',
        component: (callback) => {
            import('./../viewport/studentLeaderImport/studentLeader/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/studentleaderimport/index'
    }
    ,
    {
        path: '/studentleaderassignimport/index',
        component: (callback) => {
            import('./../viewport/studentLeaderImport/studentLeaderAssign/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/studentleaderassignimport/index'
    }
    ,
    {
        path: '/databack/list/index',
        component: (callback) => {
            import('./../viewport/manager/databack/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/databack/list/index'
    }
    ,
    {
        path: '/eval/evaluationrate/index',
        component: (callback) => {
            import('./../viewport/evals/evaluationrate/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/evaluationrate/index'
    }
    ,
    {
        path: '/teacherrank/index/1',
        component: (callback) => {
            import('./../viewport/evals/teacher/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherrank/index/1'
    }
    ,
    {
        path: '/teacherrank/index/2',
        component: (callback) => {
            import('./../viewport/evals/major/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherrank/index/2'
    }
    ,
    {
        path: '/teacherrank/index/3',
        component: (callback) => {
            import('./../viewport/evals/course/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherrank/index/3'
    }
    ,
    {
        path: '/teacherrank/index/4',
        component: (callback) => {
            import('./../viewport/evals/teachercourse/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherrank/index/4'
    }
    ,
    {
        path: '/teacherrank/index/5',
        component: (callback) => {
            import('./../viewport/evals/teacherclass/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherrank/index/5'
    }
    ,
    {
        path: '/teacherrank/index/6',
        component: (callback) => {
            import('./../viewport/evals/teacherclscou/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherrank/index/6'
    }
    ,
    {
        path: '/studentleader/grant/index',
        component: (callback) => {
            import('./../viewport/question/manage/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/studentleader/grant/index'
    }
    ,
    {
        path: '/question/category/index',
        component: (callback) => {
            import('./../viewport/question/category/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/question/category/index'
    }
    ,
    {
        path: '/question/index',
        component: (callback) => {
            import('./../viewport/question/question/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/question/index'
    }
    ,
    {
        path: '/question/detail/:id',
        component: (callback) => {
            import('./../viewport/question/question/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/question/detail/'
    }
    ,
    {
        path: '/datav/index/:url',
        component: (callback) => {
            import('./../viewport/datav/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/datav/index/'
    }
    ,
    {
        path: '/survey/publish',
        component: (callback) => {
            import('./../viewport/survey/Publish').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/survey/publish'
    }
    ,
    {
        path: '/evalsurvey/student/publish',
        component: (callback) => {
            import('./../viewport/evalSurvey/publish/student/Student').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/student/publish'
    }
    ,
    {
        path: '/evalsurvey/teacher/publish',
        component: (callback) => {
            import('./../viewport/evalSurvey/publish/teacher/Teacher').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/teacher/publish'
    }
    ,
    {
        path: '/evalsurvey/student/survey',
        component: (callback) => {
            import('./../viewport/evalSurvey/survey/student/Student').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/student/survey'
    }
    ,
    {
        path: '/evalsurvey/student/survey2',
        component: (callback) => {
            import('./../viewport/evalSurvey/survey/student/Student2').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/student/survey2'
    }
    ,
    {
        path: '/evalsurvey/teacher/survey',
        component: (callback) => {
            import('./../viewport/evalSurvey/survey/teacher/Teacher').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/teacher/survey'
    }
    ,
    {
        path: '/evalsurvey/student/result',
        component: (callback) => {
            import('./../viewport/evalSurvey/result/student/Student').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/student/result'
    }
    ,
    {
        path: '/evalsurvey/student/result2',
        component: (callback) => {
            import('./../viewport/evalSurvey/result/student/Student2').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/student/result2'
    }
    ,
    {
        path: '/evalsurvey/teacher/result',
        component: (callback) => {
            import('./../viewport/evalSurvey/result/teacher/Teacher').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/teacher/result'
    }
    ,
    {
        path: '/evalsurvey/student/analysis',
        component: (callback) => {
            import('./../viewport/evalSurvey/analysis/student/Student').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/student/analysis'
    }
    ,
    {
        path: '/evalsurvey/teacher/analysis',
        component: (callback) => {
            import('./../viewport/evalSurvey/analysis/teacher/Teacher').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/teacher/analysis'
    }
    ,
    {
        path: '/evalsurvey/student/radar',
        component: (callback) => {
            import('./../viewport/evalSurvey/radar/student/Student').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/student/radar'
    }
    ,
    {
        path: '/evalsurvey/teacher/radar',
        component: (callback) => {
            import('./../viewport/evalSurvey/radar/teacher/Teacher').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/teacher/radar'
    }
    ,
    {
        path: '/evalsurvey/student/sub',
        component: (callback) => {
            import('./../viewport/evalSurvey/sub/student/Student').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/student/sub'
    }
    ,
    {
        path: '/evalsurvey/teacher/sub',
        component: (callback) => {
            import('./../viewport/evalSurvey/sub/teacher/Teacher').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/teacher/sub'
    }
    ,
    {
        path: '/evalsurvey/student/sub2',
        component: (callback) => {
            import('./../viewport/evalSurvey/sub2/student/Student').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/student/sub2'
    }
    ,
    {
        path: '/evalsurvey/teacher/sub2',
        component: (callback) => {
            import('./../viewport/evalSurvey/sub2/teacher/Teacher').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/teacher/sub2'
    }
    ,
    {
        path: '/evalsurvey/student/sub3',
        component: (callback) => {
            import('./../viewport/evalSurvey/sub3/student/Student').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/student/sub3'
    }
    ,
    {
        path: '/evalsurvey/teacher/sub3',
        component: (callback) => {
            import('./../viewport/evalSurvey/sub3/teacher/Teacher').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/teacher/sub3'
    }
    ,
    {
        path: '/evalsurvey/student/comment',
        component: (callback) => {
            import('./../viewport/evalSurvey/comments/student/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/student/comment'
    }
    ,
    {
        path: '/evalsurvey/common/publish',
        component: (callback) => {
            import('./../viewport/evalSurvey/common/Publish').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/common/publish'
    }
    ,
    {
        path: '/evalsurvey/common/result',
        component: (callback) => {
            import('./../viewport/evalSurvey/common/Result').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/common/result'
    }
    ,
    {
        path: '/evalsurvey/common/result2',
        component: (callback) => {
            import('./../viewport/evalSurvey/common/result2').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/common/result2'
    }
    ,
    {
        path: '/evalsurvey/student/swot',
        component: (callback) => {
            import('./../viewport/evalSurvey/swot/student/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/student/swot'
    }
    ,
    {
        path: '/evalsurvey/teacher/swot',
        component: (callback) => {
            import('./../viewport/evalSurvey/swot/teacher/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/teacher/swot'
    }
    ,
    {
        path: '/evalsurvey/org/index',
        component: (callback) => {
            import('./../viewport/evalSurvey/org/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/org/index'
    }
    ,
    {
        path: '/evalsurvey/org/index2',
        component: (callback) => {
            import('./../viewport/evalSurvey/org/Query2').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/org/index2'
    }
    ,
    {
        path: '/evalsurvey/major/index/:type',
        component: (callback) => {
            import('./../viewport/evalSurvey/major/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/major/index'
    }
    ,
    {
        path: '/org/evalsurvey/teacher/percent',
        component: (callback) => {
            import('./../viewport/evalSurvey/percent/org/teacher/Teacher').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/org/evalsurvey/teacher/percent'
    }
    ,
    {
        path: '/org/evalsurvey/student/percent',
        component: (callback) => {
            import('./../viewport/evalSurvey/percent/org/student/Student').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/org/evalsurvey/student/percent'
    }
    ,
    {
        path: '/class/evalsurvey/student/percent',
        component: (callback) => {
            import('./../viewport/evalSurvey/percent/classes/student/Student').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/class/evalsurvey/student/percent'
    }
    ,
    {
        path: '/orgscore/student/analysis',
        component: (callback) => {
            import('./../viewport/evalSurvey/orgScore/student/Student').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/orgscore/student/analysis'
    }
    ,
    {
        path: '/orgscore/student/analysis2',
        component: (callback) => {
            import('./../viewport/evalSurvey/orgScore/student2/Student').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/orgscore/student/analysis2'
    }
    ,
    {
        path: '/evalSurvey/student/orgAndTargetAnalysis',
        component: (callback) => {
            import('./../viewport/evalSurvey/orgAndTargetAnalysis/student/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/student/orgAndTargetAnalysis'
    }
    ,
    {
        path: '/evalSurvey/student/orgAndTargetAnalysis2',
        component: (callback) => {
            import('./../viewport/evalSurvey/orgAndTargetAnalysis/student/Query2').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/student/orgAndTargetAnalysis2'
    }
    ,
    {
        path: '/evalSurvey/student/orgAndTargetAnalysis3',
        component: (callback) => {
            import('./../viewport/evalSurvey/orgAndTargetAnalysis/student/Query3').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/student/orgAndTargetAnalysis3'
    }
    ,
    {
        path: '/evalSurvey/associationAnalysis/student',
        component: (callback) => {
            import('./../viewport/evalSurvey/associationAnalysis/student/Student').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/associationAnalysis/student'
    }
    ,
    {
        path: '/evalSurvey/student/subjectOption/collection/:targetId',
        component: (callback) => {
            import('./../viewport/evalSurvey/studentComments/student/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/student/subjectOption/collection'
    }
    ,
    {
        path: '/evalSurvey/student/keyword/analysis',
        component: (callback) => {
            import('./../viewport/evalSurvey/keywordAnalysis/student/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/student/keyword/analysis'
    }
    ,
    {
        path: '/evalSurvey/teacher/orgAndTargetAnalysis',
        component: (callback) => {
            import('./../viewport/evalSurvey/orgAndTargetAnalysis/teacher/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/teacher/orgAndTargetAnalysis'
    }
    ,
    {
        path: '/evalSurvey/student/multiple/analysis',
        component: (callback) => {
            import('./../viewport/evalSurvey/multiple/student/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/student/multiple/analysis'
    }
    ,
    {
        path: '/evalSurvey/student/targetAnalysis',
        component: (callback) => {
            import('./../viewport/evalSurvey/targetAnalysis/student/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/student/targetAnalysis'
    }
    ,
    {
        path: '/evalSurvey/assign/index/:type',
        component: (callback) => {
            import('./../viewport/evalSurvey/assign/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/assign/index'

    }
    ,
    {
        path: '/evalSurvey/teacher/targetAnalysis',
        component: (callback) => {
            import('./../viewport/evalSurvey/targetAnalysis/teacher/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/teacher/targetAnalysis'
    }
    ,
    {
        path: '/evalSurvey/common/optionsAnalysis',
        component: (callback) => {
            import('./../viewport/evalSurvey/common/OptionsAnalysis').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/common/optionsAnalysis'
    }
    ,
    {
        path: '/evalSurvey/common/swotAnalysis',
        component: (callback) => {
            import('./../viewport/evalSurvey/common/swot/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/common/swotAnalysis'
    }
    ,
    {
        path: '/evalSurvey/common/targetAnalysis',
        component: (callback) => {
            import('./../viewport/evalSurvey/common/targetAnalysis').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/common/targetAnalysis'
    }
    ,
    {
        path: '/evalSurvey/common/optionsAnalysis2',
        component: (callback) => {
            import('./../viewport/evalSurvey/common/optionsAnalysis2').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/common/optionsAnalysis2'
    }
    ,
    {
        path: '/evalSurvey/common/swotAnalysis2',
        component: (callback) => {
            import('./../viewport/evalSurvey/common/swot2/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/common/swotAnalysis2'
    }
    ,
    {
        path: '/evalSurvey/common/targetAnalysis2',
        component: (callback) => {
            import('./../viewport/evalSurvey/common/targetAnalysis2').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/common/targetAnalysis2'
    }
    ,
    {
        path: '/evalSurvey/student/collectAnalysis',
        component: (callback) => {
            import('./../viewport/evalSurvey/collectAnalysis/student/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/student/collectAnalysis'
    }
    ,
    {
        path: '/evalSurvey/teacher/collectAnalysis',
        component: (callback) => {
            import('./../viewport/evalSurvey/collectAnalysis/teacher/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/teacher/collectAnalysis'
    }
    ,
    {
        path: '/evalSurvey/common/collectAnalysis',
        component: (callback) => {
            import('./../viewport/evalSurvey/collectAnalysis/common/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/common/collectAnalysis'
    }
    ,
    {
        path: '/evalSurvey/combine/collectAnalysis',
        component: (callback) => {
            import('./../viewport/evalSurvey/collectAnalysis/combine/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/combine/collectAnalysis'
    }
    ,
    {
        path: '/evalsurvey/statistics/index',
        component: (callback) => {
            import('./../viewport/evalSurvey/statistics/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/statistics/index'
    }
    ,
    {
        path: '/evalsurvey/statistics/index2',
        component: (callback) => {
            import('./../viewport/evalSurvey/statistics/Query2').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/statistics/index2'
    }
    ,
    {
        path: '/evalsurvey/report/index',
        component: (callback) => {
            import('./../viewport/evalSurvey/report/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/report/index'
    }
    ,
    {
        path: '/evalsurvey/report/majormatchbyschool',
        component: (callback) => {
            import('./../viewport/evalSurvey/report/MajorMatchBySchool').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/report/majormatchbyschool'
    }
    ,
    {
        path: '/evalsurvey/report/index2',
        component: (callback) => {
            import('./../viewport/evalSurvey/report/Query2').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/report/index2'
    }
    ,
    {
        path: '/evalsurvey/report/schooltype/index2',
        component: (callback) => {
            import('./../viewport/evalSurvey/report/SchoolTypeQuery').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/report/schooltype/index2'
    }
    ,
    {
        path: '/evalsurvey/comment/index',
        component: (callback) => {
            import('./../viewport/evalSurvey/surveyComment/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/comment/index'
    }
    ,
    {
        path: '/evalsurvey/surveystatistics/index',
        component: (callback) => {
            import('./../viewport/evalSurvey/surveystatistics/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/surveystatistics/index'
    }
    ,
    {
        path: '/evalsurvey/surveystatistics/index2',
        component: (callback) => {
            import('./../viewport/evalSurvey/surveystatistics/Query2').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/surveystatistics/index2'
    }
    ,
    {
        path: '/evalsurvey/surveygraduatestatistics/index',
        component: (callback) => {
            import('./../viewport/evalSurvey/surveygraduatestatistics/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/surveygraduatestatistics/index'
    }
    ,
    {
        path: '/evalsurvey/reporttable2/index',
        component: (callback) => {
            import('./../viewport/evalSurvey/reporttable2/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/reporttable2/index'
    }
    ,
    {
        path: '/evalsurvey/reportTable2byscore/index',
        component: (callback) => {
            import('./../viewport/evalSurvey/reportTable2byscore/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/reportTable2byscore/index'
    }
    ,
    {
        path: '/evalsurvey/reportTable2byfixedscore/index',
        component: (callback) => {
            import('./../viewport/evalSurvey/reportTable2byfixedscore/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/reportTable2byfixedscore/index'
    }
    ,
    {
        path: '/evalsurvey/reporttable2all/index',
        component: (callback) => {
            import('./../viewport/evalSurvey/reporttable2all/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/reporttable2all/index'
    }
    ,
    {
        path: '/evalsurvey/reporttable2byscoreall/index',
        component: (callback) => {
            import('./../viewport/evalSurvey/reporttable2byscoreall/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/reporttable2byscoreall/index'
    }
    ,
    {
        path: '/evalsurvey/reporttable2byschooltype/index',
        component: (callback) => {
            import('./../viewport/evalSurvey/reporttable2byschooltype/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/reporttable2byschooltype/index'
    }
    ,
    {
        path: '/evalsurvey/reporttable2byscoreschooltype/index',
        component: (callback) => {
            import('./../viewport/evalSurvey/reporttable2byscoreschooltype/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/reporttable2byscoreschooltype/index'
    }
    ,
    {
        path: '/evalsurvey/reporttable2bycity/index',
        component: (callback) => {
            import('./../viewport/evalSurvey/reporttable2bycity/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/reporttable2bycity/index'
    }
    ,
    {
        path: '/evalsurvey/reporttable2byscorecity/index',
        component: (callback) => {
            import('./../viewport/evalSurvey/reporttable2byscorecity/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/reporttable2byscorecity/index'
    }
    ,
    {
        path: '/evalsurvey/reporttable2byscorecityfixedscore/index',
        component: (callback) => {
            import('./../viewport/evalSurvey/reporttable2byscorecity/Query2').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/reporttable2byscorecityfixedscore/index'
    }
    ,
    {
        path: '/evalsurvey/reporttable2bymajorfixedscore/index',
        component: (callback) => {
            import('./../viewport/evalSurvey/reporttable2bymajorfixedscore/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/reporttable2bymajorfixedscore/index'
    }
    ,
    {
        path: '/evalsurvey/reportall/index',
        component: (callback) => {
            import('./../viewport/evalSurvey/reportall/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/reportall/index'
    }
    ,
    {
        path: '/evalsurvey/reportcity/index',
        component: (callback) => {
            import('./../viewport/evalSurvey/reportcity/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalsurvey/reportcity/index'
    }
    ,
    {
        path: '/eval/teacher/courseplansimple',
        component: (callback) => {
            import('./../viewport/evalTeacher/coursePlanSimple/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/teacher/courseplansimple'
    }
    ,
    {
        path: '/eval/teacher/course',
        component: (callback) => {
            import('./../viewport/evalTeacher/Course/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/teacher/course'
    }
    ,
    {
        path: '/eval/teacher/result',
        component: (callback) => {
            import('./../viewport/evalTeacher/Result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/teacher/result'
    }
    ,
    {
        path: '/eval/teacher/totalClassAll/index',
        component: (callback) => {
            import('./../viewport/evalTeacher/totalClass/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/teacher/totalClassAll/index'
    }
    ,
    {
        path: '/eval/teacher/totalClass/index/:id',
        component: (callback) => {
            import('./../viewport/evalTeacher/totalClass/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/teacher/totalClass/index'
    }
    ,
    {
        path: '/eval/teacher/detail/:id/:readonly',
        component: (callback) => {
            import('./../viewport/evalTeacher/Detail/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/teacher/detail/'
    }
    ,
    {
        path: '/eval/teacher/analysis/option',
        component: (callback) => {
            import('./../viewport/evalTeacher/analysis/option/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/teacher/analysis/option'
    }
    ,
    {
        path: '/eval/teacher/class/collect/list',
        component: (callback) => {
            import('./../viewport/evalTeacher/ClassCollect/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/teacher/class/collect/list'
    }
    ,
    {
        path: '/datav/config/index',
        component: (callback) => {
            import('../viewport/dataVConfig/dataVConfig').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/datav/config/index'
    }
    ,
    {
        path: '/analysis/evalpercentorg/index',
        component: (callback) => {
            import('./../viewport/analysis/evalPercentAnalysisByOrg/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/evalpercentorg/index'
    }
    ,
    {
        path: '/zyzg/target/index',
        component: (callback) => {
            import('./../viewport/zyzg/target/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zyzg/target/index'
    }
    ,
    {
        path: '/zyzg/subitem/index',
        component: (callback) => {
            import('./../viewport/zyzg/subitem/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zyzg/subitem/index'
    }
    ,
    {
        path: '/zyzg/entering/index/:id',
        component: (callback) => {
            import('./../viewport/zyzg/entering/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zyzg/entering/index/'
    }
    ,
    {
        path: '/zyzg/entering/detail/:id',
        component: (callback) => {
            import('./../viewport/zyzg/entering/Entering').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zyzg/entering/detail/'
    }
    ,
    {
        path: '/zyzg/result/index/:id',
        component: (callback) => {
            import('./../viewport/zyzg/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zyzg/result/index/'
    }
    ,
    {
        path: '/zyzg/result/audit/:id',
        component: (callback) => {
            import('./../viewport/zyzg/result/Audit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zyzg/result/audit/'
    }
    ,
    {
        path: '/zyzg/course/entering/index',
        component: (callback) => {
            import('./../viewport/zyzg/course/entering').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zyzg/course/entering/index'
    }
    ,
    {
        path: '/zyzg/course/result/index',
        component: (callback) => {
            import('./../viewport/zyzg/course/result').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zyzg/course/result/index'
    }
    ,
    {
        path: '/zyzg/enteringaudit/index/:id',
        component: (callback) => {
            import('./../viewport/zyzg/entering-audit/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zyzg/enteringaudit/index/'
    }
    ,
    {
        path: '/zyzg/enteringaudit/detail/:id',
        component: (callback) => {
            import('./../viewport/zyzg/entering-audit/Audit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zyzg/enteringaudit/detail/'
    }
    ,
    {
        path: '/zyzg/resultaudit/index/:id',
        component: (callback) => {
            import('./../viewport/zyzg/result-audit/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zyzg/resultaudit/index/'
    }
    ,
    {
        path: '/zyzg/resultown/index/:id',
        component: (callback) => {
            import('./../viewport/zyzg/result-own/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zyzg/resultown/index/'
    }
    ,
    {
        path: '/zyzg/resultaudit/detail/:id',
        component: (callback) => {
            import('./../viewport/zyzg/result-audit/Audit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zyzg/resultaudit/detail/'
    }
    ,
    {
        path: '/zyzg/all/index/:type',
        component: (callback) => {
            import('./../viewport/zyzg/all/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zyzg/all/index/'
    }
    ,
    {
        path: '/zyzg/all/detail/:id',
        component: (callback) => {
            import('./../viewport/zyzg/all/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zyzg/all/detail/'
    }
    ,
    {
        path: '/zyzg/view/query/:type/:targetId',
        component: (callback) => {
            import('./../viewport/zyzg/view/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zyzg/view/query/'
    }
    ,
    {
        path: '/zyzg/earlywaring/query/:type/:targetId/:score',
        component: (callback) => {
            import('./../viewport/zyzg/earlywarning/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zyzg/earlywaring/query/'
    }
    ,
    {
        path: '/zyzg/view/detail/:id/:termId',
        component: (callback) => {
            import('./../viewport/zyzg/view/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zyzg/view/detail/'
    }
    ,
    {
        path: '/zyzg/analysis/major/index',
        component: (callback) => {
            import('./../viewport/zyzg/analysis/major/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zyzg/analysis/major/index'
    }
    ,
    {
        path: '/zyzg/analysis/major/warn/index',
        component: (callback) => {
            import('./../viewport/zyzg/analysis/majorWarn/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zyzg/analysis/majo/warn/index'
    }
    ,
    {
        path: '/zyzg/analysis/swot/index',
        component: (callback) => {
            import('./../viewport/zyzg/analysis/swot/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zyzg/analysis/swot/index'
    }
    ,
    {
        path: '/kczg/entering/index/:id',
        component: (callback) => {
            import('./../viewport/zyzg/course/entering/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/kczg/entering/index/'
    }
    ,
    {
        path: '/kczg/enteringaudit/index/:id',
        component: (callback) => {
            import('./../viewport/zyzg/course/entering-audit/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/kczg/enteringaudit/index/'
    }
    ,
    {
        path: '/kczg/result/index/:id',
        component: (callback) => {
            import('./../viewport/zyzg/course/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/kczg/result/index/'
    }
    ,
    {
        path: '/kczg/resultaudit/index/:id',
        component: (callback) => {
            import('./../viewport/zyzg/course/result-audit/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/kczg/resultaudit/index/'
    }
    ,
    {
        path: '/role/auth/index',
        component: (callback) => {
            import('./../viewport/systems/role-auth/Auth').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/role/auth/index'
    }
    ,
    {
        path: '/role/auth/query/:limits',
        component: (callback) => {
            import('./../viewport/zyzg/role-auth/Auth').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/role/auth/query/'
    }
    ,
    {
        path: '/role/byid/auth/:id',
        component: (callback) => {
            import('./../viewport/systems/org-role-auth/Auth').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/role/byid/auth/'
    }
    ,
    {
        path: '/jszg/target/index',
        component: (callback) => {
            import('./../viewport/jszg/target/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/jszg/target/index'
    }
    ,
    {
        path: '/jszg/subitem/index',
        component: (callback) => {
            import('./../viewport/jszg/subitem/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/jszg/subitem/index'
    }
    ,
    {
        path: '/jszg/entering/index/:id',
        component: (callback) => {
            import('./../viewport/jszg/entering/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/jszg/entering/index/'
    }
    ,
    {
        path: '/jszg/result/index/:id',
        component: (callback) => {
            import('./../viewport/jszg/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/jszg/result/index/'
    }
    ,
    {
        path: '/jszg/result/readonly/index/:id/:readonly',
        component: (callback) => {
            import('./../viewport/jszg/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/jszg/result/readonly/index/'
    }
    ,
    {
        path: '/jszg/result/total/:id',
        component: (callback) => {
            import('./../viewport/jszg/resulttotal/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/jszg/result/total/'
    }
    ,
    {
        path: '/jszg/result/view/:id',
        component: (callback) => {
            import('./../viewport/jszg/result/View').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/jszg/result/view/'
    }
    ,
    {
        path: '/jszg/audit/index/:id',
        component: (callback) => {
            import('./../viewport/jszg/audit/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/jszg/audit/index/'
    }
    ,
    {
        path: '/jszg/audit/audit/:id',
        component: (callback) => {
            import('./../viewport/jszg/audit/Audit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/jszg/audit/audit/'
    }
    ,
    {
        path: '/jszg/assign/org/index/:type',
        component: (callback) => {
            import('./../viewport/jszg/assign/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/jszg/assign/org/index/'
    }
    ,
    {
        path: '/jszg/myenter/index/:id',
        component: (callback) => {
            import('./../viewport/jszg/myenter/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/jszg/myenter/index/'
    }
    ,
    {
        path: '/jszg/myenter/update/:id',
        component: (callback) => {
            import('./../viewport/jszg/myenter/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/jszg/myenter/update/'
    }
    ,
    {
        path: '/develop/target/index',
        component: (callback) => {
            import('./../viewport/develop/target/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/target/index'
    }
    ,
    {
        path: '/develop/subitem/index',
        component: (callback) => {
            import('./../viewport/develop/subitem/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/subitem/index'
    }
    ,
    {
        path: '/develop/student/info/query',
        component: (callback) => {
            import('./../viewport/develop/student/info/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/student/info/query'
    }
    ,
    {
        path: '/develop/student/state/query',
        component: (callback) => {
            import('./../viewport/develop/student/state/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/student/state/query'
    }
    ,
    {
        path: '/develop/student/state/detail/:id',
        component: (callback) => {
            import('./../viewport/develop/student/state/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/student/state/detail/'
    }
    ,
    {
        path: '/develop/student/result/query',
        component: (callback) => {
            import('./../viewport/develop/student/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/student/result/query'
    }
    ,
    {
        path: '/develop/student/result/detail/:id',
        component: (callback) => {
            import('./../viewport/develop/student/result/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/student/result/detail/'
    }
    ,
    {
        path: '/develop/class/auth',
        component: (callback) => {
            import('./../viewport/develop/auth/ClassAuth').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/class/auth'
    }
    ,
    {
        path: '/develop/student/audit/query',
        component: (callback) => {
            import('./../viewport/develop/student/audit/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/student/audit/query'
    }
    ,
    {
        path: '/develop/student/audit/detail/:id',
        component: (callback) => {
            import('./../viewport/develop/student/audit/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/student/audit/detail/'
    }
    ,
    {
        path: '/develop/teacher/info/query',
        component: (callback) => {
            import('./../viewport/develop/teacher/info/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/teacher/info/query'
    }
    ,
    {
        path: '/develop/teacher/state/query',
        component: (callback) => {
            import('./../viewport/develop/teacher/state/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/teacher/state/query'
    }
    ,
    {
        path: '/develop/teacher/state/detail/:id',
        component: (callback) => {
            import('./../viewport/develop/teacher/state/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/teacher/state/detail/'
    }
    ,
    {
        path: '/develop/teacher/result/query',
        component: (callback) => {
            import('./../viewport/develop/teacher/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/teacher/result/query'
    }
    ,
    {
        path: '/develop/teacher/result/detail/:id',
        component: (callback) => {
            import('./../viewport/develop/teacher/result/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/teacher/result/detail/'
    }
    ,
    {
        path: '/develop/teacher/audit/query',
        component: (callback) => {
            import('./../viewport/develop/teacher/audit/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/teacher/audit/query'
    }
    ,
    {
        path: '/develop/teacher/audit/detail/:id',
        component: (callback) => {
            import('./../viewport/develop/teacher/audit/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/teacher/audit/detail/'
    }
    ,
    {
        path: '/develop/student/result/edit/:id',
        component: (callback) => {
            import('./../viewport/develop/student/result/Edit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/student/result/edit/'
    }
    ,
    {
        path: '/develop/teacher/result/edit/:id',
        component: (callback) => {
            import('./../viewport/develop/teacher/result/Edit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/teacher/result/edit/'
    }
    ,
    {
        path: '/develop/teacher/report/query',
        component: (callback) => {
            import('./../viewport/develop/teacher/report/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/teacher/report/query'
    }
    ,
    {
        path: '/develop/teacher/report/detail/:id',
        component: (callback) => {
            import('./../viewport/develop/teacher/report/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/teacher/report/detail/'
    }
    ,
    {
        path: '/develop/student/report/query',
        component: (callback) => {
            import('./../viewport/develop/student/report/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/student/report/query'
    }
    ,
    {
        path: '/develop/student/report/detail/:id',
        component: (callback) => {
            import('./../viewport/develop/student/report/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/develop/student/report/detail/'
    }
    ,
    {
        path: '/review/sysfolder/index',
        component: (callback) => {
            import('./../viewport/review/sysfolder/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/review/sysfolder/index'
    }
    ,
    {
        path: '/review/customerfolder/index',
        component: (callback) => {
            import('./../viewport/review/customerfolder/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/review/customerfolder/index'
    }
    ,
    {
        path: '/review/auth/index',
        component: (callback) => {
            import('./../viewport/review/auth/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/review/auth/index'
    }
    ,
    {
        path: '/review/manage/index',
        component: (callback) => {
            import('./../viewport/review/filemanager/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/review/manage/index'
    }
    ,
    {
        path: '/review/video/index/*^*',
        component: (callback) => {
            import('./../viewport/review/video/Video').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/review/video/index/*^*'
    }
    ,
    {
        path: '/ciqa/base/index',
        component: (callback) => {
            import('./../viewport/ciqa/base/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/base/index'
    }
    ,
    {
        path: '/ciqa/report/index/:type1/:type2',
        component: (callback) => {
            import('./../viewport/ciqa/report/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/report/index/'
    }
    ,
    {
        path: '/ciqa/teachingsituation/list',
        component: (callback) => {
            import('./../viewport/ciqa/teachingSituation/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/teachingsituation/list'
    }
    ,
    {
        path: '/ciqa/questionsuggestion/list',
        component: (callback) => {
            import('./../viewport/ciqa/questionsuggestion/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/questionsuggestion/list'
    }
    ,
    {
        path: '/ciqa/result/index',
        component: (callback) => {
            import('./../viewport/ciqa/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/result/index'
    }
    ,
    {
        path: '/ciqa/result/detail/:id',
        component: (callback) => {
            import('./../viewport/ciqa/result/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/result/detail/'
    }
    ,
    {
        path: '/ciqa/analysis/index',
        component: (callback) => {
            import('./../viewport/ciqa/analysis/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/analysis/index'
    }
    ,
    {
        path: '/ciqa/word/index',
        component: (callback) => {
            import('./../viewport/ciqa/word/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/word/index'
    }
    ,
    {
        path: '/ciqa/vip/apply/index',
        component: (callback) => {
            import('./../viewport/ciqa/vip/Apply').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/vip/apply/index'
    }
    ,
    {
        path: '/ciqa/vip/result/index',
        component: (callback) => {
            import('./../viewport/ciqa/vip/Result').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/vip/result/index'
    }
    ,
    {
        path: '/ciqa/vip/audit/:id',
        component: (callback) => {
            import('./../viewport/ciqa/vip/Audit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/vip/audit/'
    }
    ,
    {
        path: '/ciqa/vip/a',
        component: (callback) => {
            import('./../viewport/ciqa/vip/a').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/vip/a'
    }
    ,
    {
        path: '/ciqa/vip/b',
        component: (callback) => {
            import('./../viewport/ciqa/vip/b').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/vip/b'
    }
    ,
    {
        path: '/ciqa/infocollect/index',
        component: (callback) => {
            import('./../viewport/ciqa/infoCollection/Collect').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/infocollect/index'
    }
    ,
    {
        path: '/ciqa/infocollect/result',
        component: (callback) => {
            import('./../viewport/ciqa/infoCollection/Result').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/infocollect/result'
    }
    ,
    {
        path: '/ciqa/infocollect/detail/:id',
        component: (callback) => {
            import('./../viewport/ciqa/infoCollection/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/infocollect/detail/'
    }
    ,
    {
        path: '/ciqa/memberinfocollect/index',
        component: (callback) => {
            import('./../viewport/ciqa/memberinfocollection/Collect').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/memberinfocollect/index'
    }
    ,
    {
        path: '/ciqa/memberinfocollect/result',
        component: (callback) => {
            import('./../viewport/ciqa/memberinfocollection/Result').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/memberinfocollect/result'
    }
    ,
    {
        path: '/ciqa/ciqamembercollectinfo/detail/:id',
        component: (callback) => {
            import('./../viewport/ciqa/memberinfocollection/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/ciqamembercollectinfo/detail/'
    }
    ,
    {
        path: '/ciqa/folder/index',
        component: (callback) => {
            import('./../viewport/ciqa/folder/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/folder/index'
    }
    ,
    {
        path: '/ciqa/filemanage/index',
        component: (callback) => {
            import('./../viewport/ciqa/manage/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/filemanage/index'
    }
    ,
    {
        path: '/ciqa/piaochuang/manager',
        component: (callback) => {
            import('./../viewport/ciqa/piaochuang/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ciqa/piaochuang/manager'
    }
    ,
    {
        path: '/course/assess/target/index',
        component: (callback) => {
            import('./../viewport/courseAssess/target/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/course/assess/target/index'
    }
    ,
    {
        path: '/course/assess/item/index',
        component: (callback) => {
            import('./../viewport/courseAssess/item/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/course/assess/item/index'
    }
    ,
    {
        path: '/course/assess/entering/index/:id',
        component: (callback) => {
            import('./../viewport/courseAssess/entering/Entering').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/course/assess/entering/index/'
    }
    ,
    {
        path: '/course/assess/result/index',
        component: (callback) => {
            import('./../viewport/courseAssess/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/course/assess/result/index'
    }
    ,
    {
        path: '/course/assess/result/detail/:id',
        component: (callback) => {
            import('./../viewport/courseAssess/result/Result').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/course/assess/result/detail/'
    }
    ,
    {
        path: '/course/assess/result/update/:id',
        component: (callback) => {
            import('./../viewport/courseAssess/result/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/course/assess/result/update/'
    }
    ,
    {
        path: '/course/assess/audit/index/:roleId',
        component: (callback) => {
            import('./../viewport/courseAssess/audit/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/course/assess/audit/index/'
    }
    ,
    {
        path: '/course/assess/audit/detail/:id',
        component: (callback) => {
            import('./../viewport/courseAssess/audit/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/course/assess/audit/detail/'
    }
    ,
    {
        path: '/course/assess/analysis/option',
        component: (callback) => {
            import('./../viewport/courseAssess/analysis/option/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/course/assess/analysis/option'
    }
    ,
    {
        path: '/analysis/orgevalrate',
        component: (callback) => {
            import('./../viewport/analysis/orgEvalRate/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/orgevalrate'
    }
    ,
    {
        path: '/analysis/academyevalrate',
        component: (callback) => {
            import('./../viewport/analysis/academyEvalRate/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/academyevalrate'
    }
    ,
    {
        path: '/analysis/teachereval/:itemId',
        component: (callback) => {
            import('./../viewport/teachereval/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/teachereval/'
    }
    ,
    {
        path: '/monitor/attendance/index',
        component: (callback) => {
            import('./../viewport/monitor/attendance/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/monitor/attendance/index'
    }
    ,
    {
        path: '/monitor/assessor/index',
        component: (callback) => {
            import('./../viewport/monitor/assessor/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/monitor/assessor/index'
    }
    ,
    {
        path: '/review/index',
        component: (callback) => {
            import('./../viewport/manager/review/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/review/index'
    }
    ,
    {
        path: '/person/index',
        component: (callback) => {
            import('./../viewport/person/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/person/index'
    }
    ,
    {
        path: '/school/index',
        component: (callback) => {
            import('./../viewport/manager/school/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/school/index'
    }
    ,
    {
        path: '/employee/comment/index/:itemIds/:isSimple',
        component: (callback) => {
            import('./../viewport/comment/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/employee/comment/index/'
    }
    ,
    {
        path: '/eval/result3/result/index',
        component: (callback) => {
            import('./../viewport/teacherOneselfDiagnose/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result3/result/index'
    }
    ,
    {
        path: '/eval/result3/detail/:id/:readonly',
        component: (callback) => {
            import('./../viewport/teacherOneselfDiagnose/result/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result3/detail/'
    }
    ,
    {
        path: '/zgcp/target/index',
        component: (callback) => {
            import('./../viewport/zgcp/target/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/target/index'
    }
    ,
    {
        path: '/zgcp/items/index',
        component: (callback) => {
            import('./../viewport/zgcp/items/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/items/index'
    }
    ,
    {
        path: '/zgcp/assign/index/:type',
        component: (callback) => {
            import('./../viewport/zgcp/assign/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/assign/index/'
    }
    ,
    {
        path: '/zgcp/enter/index/:id',
        component: (callback) => {
            import('./../viewport/zgcp/enter/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/enter/index/'
    }
    ,
    {
        path: '/zgcp/audit/index/:id',
        component: (callback) => {
            import('./../viewport/zgcp/audit/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/audit/index/'
    }
    ,
    {
        path: '/zgcp/audit/audit/:id',
        component: (callback) => {
            import('./../viewport/zgcp/audit/Audit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/audit/audit/'
    }
    ,
    {
        path: '/zgcp/auditresult/index/:id',
        component: (callback) => {
            import('./../viewport/zgcp/auditResult/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/auditresult/index/'
    }
    ,
    {
        path: '/zgcp/myenter/index/:id',
        component: (callback) => {
            import('./../viewport/zgcp/myenter/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/myenter/index/'
    }
    ,
    {
        path: '/zgcp/myenter/update/:id',
        component: (callback) => {
            import('./../viewport/zgcp/myenter/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/myenter/update/'
    }
    ,
    {
        path: '/zgcp/result/index/:id',
        component: (callback) => {
            import('./../viewport/zgcp/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/result/index/'
    }
    ,
    {
        path: '/zgcp/result/readonly/index/:id/:readonly',
        component: (callback) => {
            import('./../viewport/zgcp/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/result/readonly/index/'
    }
    ,
    {
        path: '/zgcp/result/total/:id',
        component: (callback) => {
            import('./../viewport/zgcp/resulttotal/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/result/total/'
    }
    ,
    {
        path: '/zgcp/result/view/:id',
        component: (callback) => {
            import('./../viewport/zgcp/result/View').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/result/view/'
    }
    ,
    {
        path: '/zgcp/result/stat/:id',
        component: (callback) => {
            import('./../viewport/zgcp/resultstat/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/result/stat/'
    }
    ,
    {
        path: '/zgcp/rateresult/view/:id',
        component: (callback) => {
            import('./../viewport/zgcp/resultstat/View').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/rateresult/view/'
    }
    ,
    {
        path: '/zgcp/analysis/major/index',
        component: (callback) => {
            import('./../viewport/zgcp/analysis/major/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/analysis/major/index'
    }
    ,
    {
        path: '/zgcp/analysis/swot/index',
        component: (callback) => {
            import('./../viewport/zgcp/analysis/swot/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/analysis/swot/index'
    }
    ,
    {
        path: '/zgcp/analysisbytype/major/index/:objectType',
        component: (callback) => {
            import('./../viewport/zgcp/analysis/major/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/analysisbytype/major/index/'
    }
    ,
    {
        path: '/zgcp/analysisbytype/swot/index/:objectType',
        component: (callback) => {
            import('./../viewport/zgcp/analysis/swot/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/analysisbytype/swot/index/'
    }
    ,
    {
        path: '/zgcp/report/result',
        component: (callback) => {
            import('./../viewport/zgcp/report/Result').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/report/result'
    }
    ,
    {
        path: '/zgcp/org/report/result',
        component: (callback) => {
            import('./../viewport/zgcp/reportByOrg/Result').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/org/report/result'
    }
    ,
    {
        path: '/datacenter/catalog/index',
        component: (callback) => {
            import('./../viewport/dataCenter/catalog/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/datacenter/catalog/index'
    }
    ,
    {
        path: '/datacenter/approval/index',
        component: (callback) => {
            import('./../viewport/dataCenter/approval/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/datacenter/approval/index'
    }
    ,
    {
        path: '/eval/result3/analysis/option',
        component: (callback) => {
            import('./../viewport/teacherOneselfDiagnose/analysis/option/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result3/analysis/option'
    }
    ,
    {
        path: '/eval/result3/analysis/multipletarget',
        component: (callback) => {
            import('./../viewport/teacherOneselfDiagnose/analysis/multipleTarget/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result3/analysis/multipletarget'
    }
    ,
    {
        path: '/api/permission/index',
        component: (callback) => {
            import('./../viewport/apiPermission/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/api/permission/index'
    }
    ,
    {
        path: '/academy/index',
        component: (callback) => {
            import('./../viewport/manager/academy/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/academy/index'
    }
    ,
    {
        path: '/zgxycp/target/index',
        component: (callback) => {
            import('./../viewport/zgxycp/target/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/target/index'
    }
    ,
    {
        path: '/zgxycp/items/index',
        component: (callback) => {
            import('./../viewport/zgxycp/items/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/items/index'
    }
    ,
    {
        path: '/zgxycp/assign/index/:type',
        component: (callback) => {
            import('./../viewport/zgxycp/assign/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/assign/index/'
    }
    ,
    {
        path: '/zgxycp/enter/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/enter/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/enter/index/'
    }
    ,
    {
        path: '/zgxycp/enter/add/:id/:date',
        component: (callback) => {
            import('./../viewport/zgxycp/enter/Insert').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/enter/add/'
    }
    ,
    {
        path: '/zgxycp/audit/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/audit/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/audit/index/'
    }
    ,
    {
        path: '/zgxycp/audit/audit/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/audit/Audit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/audit/audit/'
    }
    ,
    {
        path: '/zgxycp/auditresult/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/auditResult/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/auditresult/index/'
    }
    ,
    {
        path: '/zgxycp/single/auditresult/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/single/auditResult/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/single/auditresult/index/'
    }
    ,
    {
        path: '/zgxycp/single/auditresultByOrg/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/single/auditresultByOrg/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/single/auditresultByOrg/index/'
    }
    ,
    {
        path: '/zgxycp/myenter/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/myenter/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/myenter/index/'
    }
    ,
    {
        path: '/zgxycp/myenter/onlyEdit/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/myenter/QueryOnlyUpdate').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/myenter/onlyEdit/index/'
    }
    ,
    {
        path: '/zgxycp/myenter/edit/:id/:date',
        component: (callback) => {
            import('./../viewport/zgxycp/myenter/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/myenter/edit/'
    }
    ,
    {
        path: '/zgxycp/result/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/result/index/'
    }
    ,
    {
        path: '/zgxycp/result/readonly/index/:id/:readonly',
        component: (callback) => {
            import('./../viewport/zgxycp/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/result/readonly/index/'
    }
    ,
    {
        path: '/zgxycp/result/view/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/result/View').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/result/view/'
    }
    ,
    {
        path: '/zgxycp/result/total/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/resulttotal/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/result/total/'
    }
    ,
    {
        path: '/zgxycp/totalresult/view/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/resulttotal/View').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/totalresult/view/'
    }
    ,
    {
        path: '/zgxycp/result/stat/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/resultstat/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/result/stat/'
    }
    ,
    {
        path: '/zgxycp/statresult/view/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/resultstat/View').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/statresult/view/'
    }
    ,
    {
        path: '/zgxycp/oldenter/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/enterOld/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/oldenter/index/'
    }
    ,
    {
        path: '/zgxycp/oldmyenter/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/myenterOld/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/oldmyenter/index/'
    }
    ,
    {
        path: '/zgxycp/oldaudit/audit/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/auditOld/Audit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/oldaudit/audit/'
    }
    ,
    {
        path: '/zgxycp/earlywarning/index/:id/:objectType/:earlyScore',
        component: (callback) => {
            import('./../viewport/zgxycp/earlywarning/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/earlywarning/index/'
    }
    ,
    {
        path: '/zgxycp/earlywarning/view/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/earlywarning/View').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/earlywarning/view/'
    }
    ,
    {
        path: '/zgxycp/analysis/major/index',
        component: (callback) => {
            import('./../viewport/zgxycp/analysis/major/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/analysis/major/index'
    }
    ,
    {
        path: '/zgxycp/analysis/swot/index',
        component: (callback) => {
            import('./../viewport/zgxycp/analysis/swot/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/analysis/swot/index'
    }
    ,
    {
        path: '/zgxycp/analysis/swotConvert/index',
        component: (callback) => {
            import('./../viewport/zgxycp/analysis/swotConvert/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/analysis/swotConvert/index'
    }
    ,
    {
        path: '/zgxycp/analysis/swotExpertConvert/index',
        component: (callback) => {
            import('./../viewport/zgxycp/analysis/swotExpertConvert/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/analysis/swotExpertConvert/index'
    }
    ,
    {
        path: '/zgxycp/analysis/swotSelfAssess/index',
        component: (callback) => {
            import('./../viewport/zgxycp/analysis/swotSelfAssess/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/analysis/swotSelfAssess/index'
    }
    ,
    {
        path: '/zgxycp/analysis/swotAuthTic/index',
        component: (callback) => {
            import('./../viewport/zgxycp/analysis/swotAuthTic/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/analysis/swotAuthTic/index'
    }
    ,
    {
        path: '/zgxycp/assignview/index/:type',
        component: (callback) => {
            import('./../viewport/zgxycp/assignview/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/assignview/index/'
    }
    ,
    {
        path: '/zgxycp/result/summary/index',
        component: (callback) => {
            import('./../viewport/zgxycp/summary/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/result/summary/index'
    }
    ,
    {
        path: '/zgxycp/analysisbytype/major/index/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/analysis/major/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/analysisbytype/major/index/'
    }
    ,
    {
        path: '/zgxycp/analysisbytype/swot/index/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/analysis/swot/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/analysisbytype/swot/index/'
    }
    ,
    {
        path: '/zgxycp/analysisbytype/swotConvert/index/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/analysis/swotConvert/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/analysisbytype/swotConvert/index/'
    }
    ,
    {
        path: '/zgxycp/analysisbytype/swotExpertConvert/index/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/analysis/swotExpertConvert/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/analysisbytype/swotExpertConvert/index/'
    }
    ,
    {
        path: '/zgxycp/result/summarybytype/index/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/summary/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/result/summarybytype/index/'
    }
    ,
    {
        path: '/zgxycp/auditresultbytype/index/:id/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/auditResult/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/auditresultbytype/index/'
    }
    ,
    {
        path: '/zgxycp/auditbytype/index/:id/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/audit/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/auditbytype/index/'
    }
    ,
    {
        path: '/zgxycp/resultbytype/index/:id/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/resultbytype/index/'
    }
    ,
    {
        path: '/zgxycp/myenterbytype/index/:id/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/myenter/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/myenterbytype/index/'
    }
    ,
    {
        path: '/zgxycp/myenterbytype/onlyEdit/index/:id/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/myenter/QueryOnlyUpdate').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/myenterbytype/onlyEdit/index/'
    }
    ,
    {
        path: '/zgxycp/result/statbytype/:id/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/resultstat/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/result/statbytype/'
    }
    ,
    {
        path: '/zgxycp/org/audit/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/auditByOrg/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/org/audit/index/'
    }
    ,
    {
        path: '/zgxycp/org/audit/audit/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/auditByOrg/Audit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/org/audit/audit/'
    }
    ,
    {
        path: '/zgxycp/org/auditResult/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/auditResultByOrg/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/org/auditResult/index/'
    }
    ,
    {
        path: '/zgxycp/org/auditResultbytype/index/:id/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/auditResultByOrg/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/org/auditResultbytype/index/'
    }
    ,
    {
        path: '/zgxycp/org/auditbytype/index/:id/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/auditByOrg/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/org/auditbytype/index/'
    }
    ,
    {
        path: '/zgxycp/org/assign/index/:type',
        component: (callback) => {
            import('./../viewport/zgxycp/assignByOrg/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/org/assign/index/'
    }
    ,
    {
        path: '/zgxycp/all/subresult/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/subresultAll/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/all/subresult/index/'
    }
    ,
    {
        path: '/zgxycp/subresult/import/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/subResultImport/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/subresult/import/index/'
    }
    ,
    {
        path: '/zgxycp/org/auditNewbytype/index/:id/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/auditByOrgNew/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/org/auditNewbytype/index/'
    }
    ,
    {
        path: '/zgxycp/org/auditNew/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/auditByOrgNew/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/org/auditNew/index/'
    }
    ,
    {
        path: '/zgxycp/org/auditNew/audit/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/auditByOrgNew/Audit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/org/auditNew/audit/'
    }
    ,
    {
        path: '/zgxycp/auditNewbytype/index/:id/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/auditNew/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/auditNewbytype/index/'
    }
    ,
    {
        path: '/zgxycp/auditNew/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/auditNew/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/auditNew/index/'
    }
    ,
    {
        path: '/zgxycp/auditNew/audit/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/auditNew/Audit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/auditNew/audit/'
    }
    ,
    {
        path: '/zgxycp/audit2/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/audit2/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/audit2/index/'
    }
    ,
    {
        path: '/zgxycp/audit2/audit/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/audit2/Audit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/audit2/audit/'
    }
    ,
    {
        path: '/zgxycp/auditresult2/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/auditResult2/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/auditresult2/index/'
    }
    ,
    {
        path: '/zgxycp/team/index',
        component: (callback) => {
            import('./../viewport/zgxycp/team/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/team/index'
    }
    ,
    {
        path: '/zgxycp/analysis/fillingRate/:targetId',
        component: (callback) => {
            import('./../viewport/zgxycp/analysis/fillingRate/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/analysis/fillingRate/'
    }
    ,
    {
        path: '/zgxycp/selfAssessment/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/selfAssessment/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/selfAssessment/index/'
    }
    ,
    {
        path: '/zgxycp/selfAssessment/assess/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/selfAssessment/Assess').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/selfAssessment/assess/'
    }
    ,
    {
        path: '/zgxycp/selfAssessmentbytype/index/:id/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/selfAssessment/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/selfAssessmentbytype/index/'
    }
    ,
    {
        path: '/zgxycp/analysisbytype/swotSelfAssess/index/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/analysis/swotSelfAssess/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/analysisbytype/swotSelfAssess/index/'
    }
    ,
    {
        path: '/zgxycp/analysisbytype/majorSelfAssess/index/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/analysis/majorSelfAssess/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/analysisbytype/majorSelfAssess/index/'
    }
    ,
    {
        path: '/zgxycp/earlyWarnSelfAssess/index/:id/:objectType/:earlyScore',
        component: (callback) => {
            import('./../viewport/zgxycp/earlyWarnSelfAssess/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/earlyWarnSelfAssess/index/'
    }
    ,
    {
        path: '/zgxycp/selfAssess/targetAnalysisByOrg/index/:id/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/analysis/targetAnalysisByOrgSelfAssess/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/selfAssess/targetAnalysisByOrg/index/'
    }
    ,
    {
        path: '/zgxycp/authentication/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/authentication/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/authentication/index/'
    }
    ,
    {
        path: '/zgxycp/authentication/authen/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/authentication/AuthenTiC').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/authentication/authen/'
    }
    ,
    {
        path: '/zgxycp/authenticationbytype/index/:id/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/authentication/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/authenticationbytype/index/'
    }
    ,
    {
        path: '/zgxycp/authentication/assign/index/:type',
        component: (callback) => {
            import('./../viewport/zgxycp/assignByAuthentic/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/authentication/assign/index/'
    }
    ,
    {
        path: '/zgxycp/analysisbytype/swotAuthTic/index/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/analysis/swotAuthTic/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/analysisbytype/swotAuthTic/index/'
    }
    ,
    {
        path: '/zgxycp/analysisbytype/majorAuthTic/index/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/analysis/majorAuthTic/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/analysisbytype/majorAuthTic/index/'
    }
    ,
    {
        path: '/zgxycp/earlyWarnAuthTic/index/:id/:objectType/:earlyScore',
        component: (callback) => {
            import('./../viewport/zgxycp/earlyWarnAuthTic/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/earlyWarnAuthTic/index/'
    }
    ,
    {
        path: '/zgxycp/authTic/targetAnalysisByOrg/index/:id/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/analysis/targetAnalysisByOrgAuthTic/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/authTic/targetAnalysisByOrg/index/'
    }
    ,
    {
        path: '/zgxycp/analysisbytype/swotExpert/index/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/analysis/swotExpert/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/analysisbytype/swotExpert/index/'
    }
    ,
    {
        path: '/zgxycp/analysisbytype/majorExpert/index/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/analysis/majorExpert/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/analysisbytype/majorExpert/index/'
    }
    ,
    {
        path: '/zgxycp/earlyWarnExpert/index/:id/:objectType/:earlyScore',
        component: (callback) => {
            import('./../viewport/zgxycp/earlyWarnExpert/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/earlyWarnExpert/index/'
    }
    ,
    {
        path: '/zgxycp/file/index/:id/',
        component: (callback) => {
            import('./../viewport/zgxycp/fileView/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/file/index/'
    }
    ,
    {
        path: '/zgxycp/baseinfo/query',
        component: (callback) => {
            import('./../viewport/zgxycp/baseInfo/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/baseinfo/query'
    }
    ,
    {
        path: '/zgxycp/baseinfo/detail/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/baseInfo/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/baseinfo/detail/'
    }
    ,
    {
        path: '/zgxycp/enterNew/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/enterNew/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/enterNew/index/'
    }
    ,
    {
        path: '/zgxycp/enterNew/add/:id/:date',
        component: (callback) => {
            import('./../viewport/zgxycp/enterNew/Insert').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/enterNew/add/'
    }
    ,
    {
        path: '/zgxycp/myenterNew/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/myenterNew/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/myenterNew/index/'
    }
    ,
    {
        path: '/zgxycp/myenterNew/onlyEdit/index/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/myenterNew/QueryOnlyUpdate').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/myenterNew/onlyEdit/index/'
    }
    ,
    {
        path: '/zgxycp/myenterNew/editNew/:id/:targetId/:date',
        component: (callback) => {
            import('./../viewport/zgxycp/myenterNew/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/myenterNew/editNew/'
    }
    ,
    {
        path: '/zgxycp/myenterNewbytype/index/:id/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/myenterNew/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/myenterNewbytype/index/'
    }
    ,
    {
        path: '/zgxycp/myenterNewbytype/onlyEdit/index/:id/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/myenterNew/QueryOnlyUpdate').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/myenterNewbytype/onlyEdit/index/'
    }
    ,
    {
        path: '/zgxycp/sysParam/index',
        component: (callback) => {
            import('./../viewport/zgxycp/sysParam/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/sysParam/index'
    }
    ,

    {
        path: '/zgxycp/expert/assign/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/expertAssign/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/expert/assign/'
    }
    ,

    {
        path: '/zgxycp/expert/assignbytype/:id/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/expertAssign/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/expert/assignbytype/'
    }
    ,

    {
        path: '/zgxycp/expert/review/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/expertReview/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/expert/review/'
    }
    ,

    {
        path: '/zgxycp/expert/reviewbytype/:id/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/expertReview/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/expert/reviewbytype/'
    }
    ,

    {
        path: '/zgxycp/expert/audit/:id/:resultId/:targetId',
        component: (callback) => {
            import('./../viewport/zgxycp/expertReview/Audit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/expert/audit/'
    }
    ,

    {
        path: '/zgxycp/expert/result/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/expertResult/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/expert/result/'
    }
    ,

    {
        path: '/zgxycp/expert/resultbytype/:id/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/expertResult/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/expert/resultbytype/'
    }
    ,

    {
        path: '/zgxycp/expert/total/:id',
        component: (callback) => {
            import('./../viewport/zgxycp/expertResultTotal/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/expert/total/'
    }
    ,

    {
        path: '/zgxycp/expert/totalShowExpert/:id',
        component: (callback) => {
            import('../viewport/zgxycp/expertResultTotal2/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/expert/totalShowExpert/'
    }
    ,

    {
        path: '/zgxycp/expert/totalbytype/:id/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/expertResultTotal/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/expert/totalbytype/'
    }
    ,

    {
        path: '/zgxycp/expert/resultTotal/:resultId/:targetId',
        component: (callback) => {
            import('./../viewport/zgxycp/expertResultTotal/Audit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/expert/resultTotal/'
    }
    ,

    {
        path: '/zgxycp/expert/resultTotal2/:resultId/:targetId',
        component: (callback) => {
            import('./../viewport/zgxycp/expertResultTotal2/Audit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/expert/resultTotal2/'
    }
    ,
    {
        path: '/leader/listen/index',
        component: (callback) => {
            import('./../viewport/leaderListen/insert/LeaderInsert').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/leader/listen/index'
    }
    ,
    {
        path: '/leader/listen/result',
        component: (callback) => {
            import('./../viewport/leaderListen/result/LeaderResult').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/leader/listen/result'
    }
    ,
    {
        path: '/leader/listen/allresult',
        component: (callback) => {
            import('./../viewport/leaderListen/result/LeaderAllResult').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/leader/listen/allresult'
    }
    ,
    {
        path: '/leader/listen/detail/:id',
        component: (callback) => {
            import('./../viewport/leaderListen/result/LeaderDetail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/leader/listen/detail/'
    }
    ,
    {
        path: '/leader/listen/edit/:id',
        component: (callback) => {
            import('./../viewport/leaderListen/result/LeaderEdit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/leader/listen/edit/'
    }
    ,
    {
        path: '/leader/listen/analysis/targetanalysisbyoptions/index',
        component: (callback) => {
            import('./../viewport/leaderListen/analysis/leaderTargetAnalysisByOptions/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/leader/listen/analysis/targetanalysisbyoptions/index'
    }
    ,
    {
        path: '/leader/listen/analysis/targetanalysisbyorg/index',
        component: (callback) => {
            import('./../viewport/leaderListen/analysis/leaderTargetAnalysisByOrg/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/leader/listen/analysis/targetanalysisbyorg/index'
    }
    ,
    {
        path: '/peer/review/index',
        component: (callback) => {
            import('./../viewport/leaderListen/insert/PeerInsert').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/peer/review/index'
    }
    ,
    {
        path: '/peer/review/result',
        component: (callback) => {
            import('./../viewport/leaderListen/result/PeerResult').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/peer/review/result'
    }
    ,
    {
        path: '/peer/review/detail/:id',
        component: (callback) => {
            import('../viewport/leaderListen/result/PeerDetail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/peer/review/detail/'
    }
    ,
    {
        path: '/peer/review/edit/:id',
        component: (callback) => {
            import('../viewport/leaderListen/result/PeerUpdate').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/peer/review/edit/'
    }
    ,
    {
        path: '/teacher/listen/index',
        component: (callback) => {
            import('./../viewport/leaderListen/insert/TeacherInsert').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacher/listen/index'
    }
    ,
    {
        path: '/teacher/listen/result',
        component: (callback) => {
            import('./../viewport/leaderListen/result/TeacherResult').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacher/listen/result'
    }
    ,
    {
        path: '/teacher/listen/allresult',
        component: (callback) => {
            import('./../viewport/leaderListen/result/TeacherAllResult').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacher/listen/allresult'
    }
    ,
    {
        path: '/teacher/listen/detail/:id',
        component: (callback) => {
            import('./../viewport/leaderListen/result/TeacherDetail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacher/listen/detail/'
    }
    ,
    {
        path: '/teacher/listen/edit/:id',
        component: (callback) => {
            import('./../viewport/leaderListen/result/TeacherEdit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacher/listen/edit/'
    }
    ,
    {
        path: '/teacher/listen/analysis/targetanalysisbyoptions/index',
        component: (callback) => {
            import('./../viewport/leaderListen/analysis/teacherTargetAnalysisByOptions/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacher/listen/analysis/targetanalysisbyoptions/index'
    }
    ,
    {
        path: '/teacher/listen/analysis/targetanalysisbyorg/index',
        component: (callback) => {
            import('./../viewport/leaderListen/analysis/teacherTargetAnalysisByOrg/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacher/listen/analysis/targetanalysisbyorg/index'
    }
    ,
    {
        path: '/second/credit/target/index',
        component: (callback) => {
            import('./../viewport/secondCredit/target/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/target/index'
    }
    ,
    {
        path: '/second/credit/items/index',
        component: (callback) => {
            import('./../viewport/secondCredit/items/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/items/index'
    }
    ,
    {
        path: '/second/credit/assign/index/:type',
        component: (callback) => {
            import('./../viewport/secondCredit/assign/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/assign/index/'
    }
    ,
    {
        path: '/second/credit/assign/school/index/:type',
        component: (callback) => {
            import('./../viewport/secondCredit/assignBySchool/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/assign/school/index/'
    }
    ,
    {
        path: '/second/credit/enter/index/:id',
        component: (callback) => {
            import('./../viewport/secondCredit/enter/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/enter/index/'
    }
    ,
    {
        path: '/second/credit/audit/index/:id',
        component: (callback) => {
            import('./../viewport/secondCredit/audit/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/audit/index/'
    }
    ,
    {
        path: '/second/credit/audit/audit/:id',
        component: (callback) => {
            import('./../viewport/secondCredit/audit/Audit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/audit/audit/'
    }
    ,
    {
        path: '/second/credit/myenter/index/:id',
        component: (callback) => {
            import('./../viewport/secondCredit/myenter/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/myenter/index/'
    }
    ,
    {
        path: '/second/credit/myenterView/index/:id',
        component: (callback) => {
            import('../viewport/secondCredit/myenter/QueryOnlyView').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/myenterView/index/'
    }
    ,
    {
        path: '/second/credit/myenter/edit/:id',
        component: (callback) => {
            import('./../viewport/secondCredit/myenter/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/myenter/edit/'
    }
    ,
    {
        path: '/second/credit/result/index/:id',
        component: (callback) => {
            import('./../viewport/secondCredit/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/result/index/'
    }
    ,
    {
        path: '/second/credit/result/readonly/index/:id/:readonly',
        component: (callback) => {
            import('./../viewport/secondCredit/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/result/readonly/index/'
    }
    ,
    {
        path: '/second/credit/result/view/:id',
        component: (callback) => {
            import('./../viewport/secondCredit/result/View').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/result/view/'
    }
    ,
    // {
    //     path: '/second/credit/result/total/:id',
    //     component: (callback) => {
    //         import('./../viewport/secondCredit/resulttotal/Query').then((Products)=>{
    //             callback(Products.default);
    //         });
    //     },
    //     name: '/second/credit/result/total/'
    // }
    // ,
    // {
    //     path: '/second/credit/totalresult/view/:id',
    //     component: (callback) => {
    //         import('./../viewport/secondCredit/resulttotal/View').then((Products)=>{
    //             callback(Products.default);
    //         });
    //     },
    //     name: '/second/credit/totalresult/view/'
    // }
    // ,
    {
        path: '/second/credit/result/stat/:id',
        component: (callback) => {
            import('./../viewport/secondCredit/resultstat/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/result/stat/'
    }
    ,
    {
        path: '/second/credit/statresult/view/:id',
        component: (callback) => {
            import('./../viewport/secondCredit/resultstat/View').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/statresult/view/'
    }
    ,
    {
        path: '/second/credit/analysis/major/index',
        component: (callback) => {
            import('./../viewport/secondCredit/analysis/major/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/analysis/major/index'
    }
    ,
    {
        path: '/second/credit/analysis/swot/index',
        component: (callback) => {
            import('./../viewport/secondCredit/analysis/swot/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/analysis/swot/index'
    }
    ,
    {
        path: '/second/credit/analysis/fillingRate/index',
        component: (callback) => {
            import('./../viewport/secondCredit/analysis/fillingRate/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/analysis/fillingRate/index'
    }
    ,
    {
        path: '/second/credit/analysis/fillingRate/view/index',
        component: (callback) => {
            import('./../viewport/secondCredit/analysis/fillingRateView/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/analysis/fillingRate/view/index'
    }
    ,
    {
        path: '/second/credit/assignview/index',
        component: (callback) => {
            import('./../viewport/secondCredit/assignview/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/assignview/index'
    }
    ,
    // {
    //     path: '/second/credit/result/summarybytype/index/:objectType',
    //     component: (callback) => {
    //         import('./../viewport/secondCredit/summary/Query').then((Products)=>{
    //             callback(Products.default);
    //         });
    //     },
    //     name: '/second/credit/result/summarybytype/index/'
    // }
    // ,
    // {
    //     path: '/second/credit/result/summary/index',
    //     component: (callback) => {
    //         import('./../viewport/secondCredit/summary/Query').then((Products)=>{
    //             callback(Products.default);
    //         });
    //     },
    //     name: '/second/credit/result/summary/index'
    // }
    // ,
    {
        path: '/second/credit/subresult/index/:id',
        component: (callback) => {
            import('./../viewport/secondCredit/subresult/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/subresult/index/'
    }
    ,
    {
        path: '/second/credit/mysubenter/index/:id',
        component: (callback) => {
            import('./../viewport/secondCredit/mysubenter/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/mysubenter/index/'
    }
    ,
    {
        path: '/second/credit/auditresult/index/:id',
        component: (callback) => {
            import('./../viewport/secondCredit/auditresult/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/auditresult/index/'
    }
    ,
    {
        path: '/second/credit/auditresultbyorg/index/:id',
        component: (callback) => {
            import('./../viewport/secondCredit/auditresultByOrg/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/auditresultbyorg/index/'
    }
    ,
    {
        path: '/second/credit/auditresultbyschool/index/:id',
        component: (callback) => {
            import('./../viewport/secondCredit/auditresultBySchool/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/auditresultbyschool/index/'
    }
    ,
    {
        path: '/second/credit/publish/query',
        component: (callback) => {
            import('./../viewport/secondCredit/publish/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/publish/query'
    }
    ,
    {
        path: '/second/credit/publish/result/query',
        component: (callback) => {
            import('./../viewport/secondCredit/publishResult/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/publish/result/query'
    }
    ,
    {
        path: '/second/credit/classauth/query',
        component: (callback) => {
            import('./../viewport/secondCredit/classAuth/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/classauth/query'
    }
    ,
    {
        path: '/second/credit/groupclassauth/query',
        component: (callback) => {
            import('./../viewport/secondCredit/groupClassAuth/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/groupclassauth/query'
    }
    ,
    {
        path: '/second/credit/earlywarning/index',
        component: (callback) => {
            import('./../viewport/secondCredit/earlywarning/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/earlywarning/index'
    }
    ,
    {
        path: '/second/credit/notification/query',
        component: (callback) => {
            import('./../viewport/secondCredit/notification/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/notification/query'
    }
    ,
    {
        path: '/second/credit/subenterall/index/:id',
        component: (callback) => {
            import('./../viewport/secondCredit/subenterAll/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/subenterall/index/'
    }
    ,
    {
        path: '/second/credit/collect/query',
        component: (callback) => {
            import('./../viewport/secondCredit/collect/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/collect/query'
    }
    ,
    {
        path: '/second/credit/collect2/query',
        component: (callback) => {
            import('./../viewport/secondCredit/collect2/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/collect2/query'
    }
    ,
    {
        path: '/patrol/class/options/:optionId',
        component: (callback) => {
            import('./../viewport/patrol/Query2').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/patrol/class/options'
    }
    ,
    {
        path: '/patrol/class/index',
        component: (callback) => {
            import('./../viewport/patrol/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/patrol/class/index'
    }
    ,
    {
        path: '/patrol/options/index',
        component: (callback) => {
            import('./../viewport/patrol/options/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/patrol/options/index'
    }
    ,
    {
        path: '/patrol/class/result',
        component: (callback) => {
            import('./../viewport/patrol/Result').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/patrol/class/result'
    }
    ,
    {
        path: '/patrol/class/optionresult',
        component: (callback) => {
            import('./../viewport/patrol/Result2').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/patrol/class/optionresult'
    }
    ,
    {
        path: '/patrol/class/readonly/optionresult',
        component: (callback) => {
            import('./../viewport/patrol/Result2ReadOnly').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/patrol/class/readonly/optionresult/'
    }
    ,
    {
        path: '/patrol/class/verify',
        component: (callback) => {
            import('./../viewport/patrol/Verify').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/patrol/class/verify'
    }
    ,
    {
        path: '/patrol/class/inputs/:itemId/:itemPid/:planId',
        component: (callback) => {
            import('./../viewport/patrol/PatrolInputs/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/patrol/class/inputs/'
    }
    ,
    {
        path: '/second/credit/leadin/query',
        component: (callback) => {
            import('./../viewport/secondCredit/leadin/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/second/credit/leadin/query'
    }
    ,
    {
        path: '/graduation/form/template',
        component: (callback) => {
            import('./../viewport/graduation/formEntring/template/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/form/template'
    }
    ,
    {
        path: '/graduation/form/addTemplate',
        component: (callback) => {
            import('./../viewport/graduation/formEntring/template/Insert').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/form/addTemplate'
    }
    ,
    {
        path: '/graduation/form/editTemplate/:id',
        component: (callback) => {
            import('./../viewport/graduation/formEntring/template/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/form/editTemplate'
    }
    ,
    {
        path: '/graduation/form/detailTemplate/:id',
        component: (callback) => {
            import('./../viewport/graduation/formEntring/template/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/form/detailTemplate'
    }
    ,
    {
        path: '/graduation/courses/sysParam/index',
        component: (callback) => {
            import('./../viewport/graduation/sysParam/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/courses/sysParam/index'
    }
    ,
    {
        path: '/graduation/coursesignup/query',
        component: (callback) => {
            import('./../viewport/graduation/signup/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/coursesignup/query'
    }
    ,
    {
        path: '/graduation/coursesignup/view/query',
        component: (callback) => {
            import('./../viewport/graduation/signup-view/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/coursesignup/view/query'
    }
    ,
    {
        path: '/graduation/coursesignup/total/query',
        component: (callback) => {
            import('./../viewport/graduation/signup-total/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/coursesignup/total/query'
    }
    ,
    {
        path: '/graduation/courseentring/:id',
        component: (callback) => {
            import('./../viewport/graduation/course/CourseEntring').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/courseentring/'
    }
    ,
    {
        path: '/graduation/courseentringAll/:id',
        component: (callback) => {
            import('./../viewport/graduation/course/CourseEntringAll').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/courseentringAll/'
    }
    ,
    {
        path: '/graduation/courseresult',
        component: (callback) => {
            import('./../viewport/graduation/course/CourseResult').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/courseresult'
    }
    ,
    {
        path: '/graduation/courseresult2/:templateId',
        component: (callback) => {
            import('./../viewport/graduation/course/courseresult2').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/courseresult2'
    }
    ,
    {
        path: '/graduation/courseresultAll2/:templateId',
        component: (callback) => {
            import('./../viewport/graduation/course/CourseResultAll2').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/courseresultAll2'
    }
    ,
    {
        path: '/graduation/zyaudit/courseresult',
        component: (callback) => {
            import('./../viewport/graduation/course/CourseResultZyAudit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/zyaudit/courseresult'
    }
    ,
    {
        path: '/graduation/xbaudit/courseresult',
        component: (callback) => {
            import('./../viewport/graduation/course/CourseResultXbAudit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/xbaudit/courseresult'
    }
    ,
    {
        path: '/graduation/xjaudit/courseresult',
        component: (callback) => {
            import('./../viewport/graduation/course/CourseResultXjAudit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/xjaudit/courseresult'
    }
    ,
    {
        path: '/graduation/zyaudit/courseresult2/:templateId',
        component: (callback) => {
            import('./../viewport/graduation/course/CourseResultZyAudit2').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/zyaudit/courseresult2/'
    }
    ,
    {
        path: '/graduation/xbaudit/courseresult2/:templateId',
        component: (callback) => {
            import('./../viewport/graduation/course/CourseResultXbAudit2').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/xbaudit/courseresult2/'
    }
    ,
    {
        path: '/graduation/xjaudit/courseresult2/:templateId',
        component: (callback) => {
            import('./../viewport/graduation/course/CourseResultXjAudit2').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/xjaudit/courseresult2/'
    }
    ,
    {
        path: '/graduation/courseresult3/:templateId',
        component: (callback) => {
            import('./../viewport/graduation/course/CourseResult3').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/courseresult3/'
    }
    ,
    {
        path: '/graduation/view/courseresult',
        component: (callback) => {
            import('./../viewport/graduation/course/CourseResultView').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/view/courseresult'
    }
    ,
    // {
    //     path: '/graduation/showcourseresultdetail',
    //     component: (callback) => {
    //         import('./../viewport/graduation/course/CourseResultShowDetail').then((Products)=>{
    //             callback(Products.default);
    //         });
    //     },
    //     name: '/graduation/showcourseresultdetail'
    // }
    // ,
    {
        path: '/graduation/coursedeta/:id',
        component: (callback) => {
            import('./../viewport/graduation/course/CourseDetail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/coursedeta/'
    }
    ,
    {
        path: '/graduation/courseupda/:id',
        component: (callback) => {
            import('./../viewport/graduation/course/CourseUpdate').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/courseupda/'
    }
    ,
    {
        path: '/graduation/assign/coursecheck',
        component: (callback) => {
            import('./../viewport/graduation/course/CourseQuery').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/assign/coursecheck'
    }
    ,
    {
        path: '/graduation/course/role/auth/:limits',
        component: (callback) => {
            import('./../viewport/graduation/role-auth/Auth').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/course/role/auth/'
    }
    ,
    {
        path: '/graduation/course/result/assign/:assignType',
        component: (callback) => {
            import('./../viewport/graduation/result-assign/Auth').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/course/result/assign/'
    }
    ,
    {
        path: '/graduation/assign/courseinputs/:itemId/:id',
        component: (callback) => {
            import('./../viewport/graduation/course/CourseInputs').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/assign/courseinputs/'
    }
    ,
    {
        path: '/graduation/assign/coursedetail/:id/:readonly?/:showDudaoName?',
        component: (callback) => {
            import('./../viewport/graduation/course/CourseApprovalDetail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/assign/coursedetail/'
    }
    ,
    {
        path: '/graduation/assign/coursemasterquery/:targetId',
        component: (callback) => {
            import('./../viewport/graduation/course/CourseMasterQuery').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/assign/coursemasterquery/'
    }
    ,
    {
        path: '/graduation/coursemasterresult/:targetId',
        component: (callback) => {
            import('./../viewport/graduation/course/CourseMasterResult').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/coursemasterresult/'
    }
    ,
    {
        path: '/graduation/courseresultstatistics',
        component: (callback) => {
            import('./../viewport/graduation/course/CourseResultStatistics').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/courseresultstatistics'
    }
    ,
    {
        path: '/graduation/analysis/course/targetAnalysisByOrg',
        component: (callback) => {
            import('./../viewport/graduation/analysisCourse/targetAnalysisByOrg').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/analysis/course/targetAnalysisByOrg'
    }
    ,
    {
        path: '/graduation/analysis/course/targetAnalysisByTarget',
        component: (callback) => {
            import('./../viewport/graduation/analysisCourse/targetAnalysisByTarget').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/analysis/course/targetAnalysisByTarget'
    }
    ,
    {
        path: '/graduation/analysis/course/targetAnalysisByOptions',
        component: (callback) => {
            import('./../viewport/graduation/analysisCourse/targetAnalysisByOptions').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/analysis/course/targetAnalysisByOptions'
    }
    ,
    {
        path: '/graduation/analysis/course/targetAnalysisBySwot',
        component: (callback) => {
            import('./../viewport/graduation/analysisCourse/targetAnalysisBySwot').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/analysis/course/targetAnalysisBySwot'
    }
    ,
    {
        path: '/graduation/master',
        component: (callback) => {
            import('./../viewport/graduation/master/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/master'
    }
    ,
    {
        path: '/master/role/index',
        component: (callback) => {
            import('./../viewport/systems/masterRoles/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/master/role/index'
    }
    ,
    {
        path: '/graduation/template',
        component: (callback) => {
            import('./../viewport/graduation/template/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/template'
    }
    ,
    {
        path: '/graduation/entring/:id',
        component: (callback) => {
            import('./../viewport/graduation/entring/Entring').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/entring/'
    }
    ,
    {
        path: '/graduation/newentring/:id',
        component: (callback) => {
            import('./../viewport/graduation/entring/Entring2').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/newentring/'
    }
    ,
    {
        path: '/graduation/fileDownload',
        component: (callback) => {
            import('./../viewport/graduation/filedownload/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/fileDownload'
    }
    ,
    {
        path: '/graduation/result',
        component: (callback) => {
            import('./../viewport/graduation/result/Result').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/result'
    }
    ,
    {
        path: '/graduation/employeeresult',
        component: (callback) => {
            import('./../viewport/graduation/result/EmployeeResult').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/employeeresult'
    }
    ,
    {
        path: '/graduation/employeeupdaterst/:id',
        component: (callback) => {
            import('./../viewport/graduation/result/EmployeeUpdate').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/employeeupdaterst/'
    }
    ,
    {
        path: '/graduation/detailrst/:id',
        component: (callback) => {
            import('./../viewport/graduation/result/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/detailrst/'
    }
    ,
    {
        path: '/graduation/updarst/:id',
        component: (callback) => {
            import('./../viewport/graduation/result/Update').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/updarst/'
    }
    ,
    {
        path: '/graduation/check',
        component: (callback) => {
            import('./../viewport/graduation/check/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/check'
    }
    ,
    {
        path: '/graduation/detailcheck/:id',
        component: (callback) => {
            import('./../viewport/graduation/check/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/detailcheck/'
    }
    ,
    {
        path: '/graduation/approval/:id',
        component: (callback) => {
            import('./../viewport/graduation/check/Approval').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/approval/'
    }
    ,
    {
        path: '/graduation/assign/org',
        component: (callback) => {
            import('./../viewport/graduation/assignOrg/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/assign/org'
    }
    ,
    {
        path: '/graduation/assign/check',
        component: (callback) => {
            import('./../viewport/graduation/assignCheck/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/assign/check'
    }
    ,
    {
        path: '/graduation/assign/masterquery',
        component: (callback) => {
            import('./../viewport/graduation/assignCheck/MasterQuery').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/assign/masterquery'
    }
    ,
    {
        path: '/graduation/assign/result/:id',
        component: (callback) => {
            import('./../viewport/graduation/assignCheck/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/assign/result/'
    }
    ,
    {
        path: '/graduation/assign/file/:id',
        component: (callback) => {
            import('./../viewport/graduation/assignCheck/File').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/assign/file/'
    }
    ,
    {
        path: '/graduation/assign/coursefile/:id',
        component: (callback) => {
            import('./../viewport/graduation/assignCheck/File').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/assign/coursefile/'
    }
    ,
    {
        path: '/graduation/assign/approval/:id',
        component: (callback) => {
            import('./../viewport/graduation/assignCheck/Approval').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/assign/approval/'
    }
    ,
    {
        path: '/graduation/assign/inputs/:itemId/:id',
        component: (callback) => {
            import('./../viewport/graduation/assignCheck/Inputs').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/assign/inputs/'
    }
    ,
    {
        path: '/graduation/assign/detail/:id/:readonly?/:showDudaoName?',
        component: (callback) => {
            import('./../viewport/graduation/assignCheck/ApprovalDetail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/assign/detail/'
    }
    ,
    {
        path: '/graduation/majorfeedback',
        component: (callback) => {
            import('./../viewport/graduation/majorfeedback/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/majorfeedback'
    }
    ,
    {
        path: '/graduation/major/eval/score/index/:itemId',
        component: (callback) => {
            import('./../viewport/graduation/majorevalscore/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/major/eval/score/index/'
    }
    ,
    {
        path: '/graduation/major/eval/score/result/:itemId/:readonly?',
        component: (callback) => {
            import('./../viewport/graduation/majorevalscore/Result').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/major/eval/score/result/'
    }
    ,
    {
        path: '/graduation/major/eval/score/detail/:id/:readonly?',
        component: (callback) => {
            import('./../viewport/graduation/majorevalscore/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/major/eval/score/detail/'
    }
    ,
    {
        path: '/graduation/masterresult',
        component: (callback) => {
            import('./../viewport/graduation/masterResult/Result').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/masterresult'
    }
    ,
    {
        path: '/graduation/masternewresult',
        component: (callback) => {
            import('./../viewport/graduation/masterResult/newResult').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/masternewresult'
    }
    ,
    {
        path: '/graduation/resultImportById/index/:id',
        component: (callback) => {
            import('./../viewport/graduation/resultImport/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/resultImportById/index'
    }
    ,
    {
        path: '/graduation/resultImport/index',
        component: (callback) => {
            import('./../viewport/graduation/resultImport/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/resultImport/index'
    }
    ,
    {
        path: '/graduation/targetanalysisbyorg/index',
        component: (callback) => {
            import('./../viewport/graduation/analysis/targetAnalysisByOrg/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/targetanalysisbyorg/index'
    }
    ,
    {
        path: '/graduation/customizetarget/index',
        component: (callback) => {
            import('./../viewport/graduation/analysis/customizeTarget/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/customizetarget/index'
    }
    ,
    {
        path: '/graduation/multipletargetanalysis/index',
        component: (callback) => {
            import('./../viewport/graduation/analysis/multipleTargetAnalysis/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/multipletargetanalysis/index'
    }
    ,
    {
        path: '/graduation/targetanalysisbyoptions/index',
        component: (callback) => {
            import('./../viewport/graduation/analysis/targetAnalysisByOptions/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/targetanalysisbyoptions/index'
    }
    ,
    {
        path: '/graduation/keywordanalysis/index',
        component: (callback) => {
            import('./../viewport/graduation/analysis/keywordAnalysis/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/keywordanalysis/index'
    }
    ,
    {
        path: '/graduation/legislation',
        component: (callback) => {
            import('./../viewport/graduation/legislation/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/legislation'
    }
    ,
    {
        path: '/graduation/employeeupdaterstnew/:id',
        component: (callback) => {
            import('./../viewport/graduation/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/employeeupdaterstnew/'
    }
    ,
    {
        path: '/graduation/templateentring/:id',
        component: (callback) => {
            import('./../viewport/graduation/entring/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/templateentring/'
    }
    ,
    {
        path: '/graduationentring/legislation/create',
        component: (callback) => {
            import('./../viewport/graduationEntring/legislationCreate/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduationentring/legislation/create'
    }
    ,
    {
        path: '/graduationentring/legislation/select',
        component: (callback) => {
            import('./../viewport/graduationEntring/legislationSelect/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduationentring/legislation/select'
    }
    ,
    {
        path: '/graduationentring/legislation/audit',
        component: (callback) => {
            import('./../viewport/graduationEntring/legislationAudit/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduationentring/legislation/audit'
    }
    ,
    {
        path: '/graduationentring/entring/result',
        component: (callback) => {
            import('./../viewport/graduationEntring/entringResult/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduationentring/entring/result'
    }
    ,
    {
        path: '/graduationentring/updaterst/:id',
        component: (callback) => {
            import('./../viewport/graduationEntring/entringResult/Updaterst').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduationentring/updaterst/'
    }
    ,
    {
        path: '/graduationentring/result/audit',
        component: (callback) => {
            import('./../viewport/graduationEntring/auditResult/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduationentring/result/audit'
    }
    ,
    {
        path: '/graduationentring/audit/:id',
        component: (callback) => {
            import('./../viewport/graduationEntring/auditResult/Audit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduationentring/audit/'
    }
    ,
    {
        path: '/master/edit/index',
        component: (callback) => {
            import('./../viewport/graduation/master/Edit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/master/edit/index'
    }
    ,
    {
        path: '/master/pwd/index',
        component: (callback) => {
            import('./../viewport/graduation/master/MasterUpdatePwd').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/master/pwd/index'
    }
    ,
    {
        path: '/expenseimport/index',
        component: (callback) => {
            import('./../viewport/supv/expenseImport/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/expenseimport/index'
    }
    ,
    {
        path: '/supvimport/index',
        component: (callback) => {
            import('./../viewport/supv/taskImport/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvimport/index'
    }
    ,
    {
        path: '/supvfileimport/index',
        component: (callback) => {
            import('./../viewport/supv/fileImport/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvfileimport/index'
    }
    ,
    {
        path: '/supvfiledownload/index',
        component: (callback) => {
            import('./../viewport/supv/fileDownload/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvfiledownload/index'
    }
    ,
    {
        path: '/supvcategory/index',
        component: (callback) => {
            import('./../viewport/supv/category/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvcategory/index'
    }
    ,
    {
        path: '/supvCategory/items/index',
        component: (callback) => {
            import('./../viewport/supv/items/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvCategory/items/index'
    }
    ,
    {
        path: '/supvtaskcreate/index',
        component: (callback) => {
            import('./../viewport/supv/taskCreate/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvtaskcreate/index'
    }
    ,
    {
        path: '/supvtaskcreateByCate/index/:cateId',
        component: (callback) => {
            import('./../viewport/supv/taskCreate/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvtaskcreateByCate/index'
    }
    ,
    {
        path: '/supvTaskApproval/index',
        component: (callback) => {
            import('./../viewport/supv/taskApproval/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskApproval/index'
    }
    ,
    {
        path: '/supvTaskApprovalByCate/index/:cateId',
        component: (callback) => {
            import('./../viewport/supv/taskApproval/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskApprovalByCate/index'
    }
    ,
    {
        path: '/supvTaskOnlyView/index/:readonly',
        component: (callback) => {
            import('./../viewport/supv/taskView/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskOnlyView/index/'
    }
    ,
    {
        path: 'supvTaskView/index',
        component: (callback) => {
            import('./../viewport/supv/taskView/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: 'supvTaskView/index'
    }
    ,
    {
        path: '/supvTaskOnlyViewByCate/index/:readonly/:cateId',
        component: (callback) => {
            import('./../viewport/supv/taskView/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskOnlyViewByCate/index/'
    }
    ,
    {
        path: 'supvTaskViewByCate/index/:cateId',
        component: (callback) => {
            import('./../viewport/supv/taskView/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: 'supvTaskViewByCate/index'
    }
    ,
    {
        path: '/supvTaskSummary/index',
        component: (callback) => {
            import('./../viewport/supv/taskSummary/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskSummary/index'
    }
    ,
    {
        path: '/supvTaskSummaryByCate/index/:cateId',
        component: (callback) => {
            import('./../viewport/supv/taskSummary/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskSummaryByCate/index'
    }
    ,
    {
        path: '/supvTaskActive/index',
        component: (callback) => {
            import('./../viewport/supv/taskActive/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskActive/index'
    }
    ,
    {
        path: '/supvTaskActiveByCate/index/:cateId',
        component: (callback) => {
            import('./../viewport/supv/taskActive/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskActiveByCate/index'
    }
    ,
    {
        path: '/supvTaskAudit/index',
        component: (callback) => {
            import('./../viewport/supv/taskAudit/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskAudit/index'
    }
    ,
    {
        path: '/supvTaskAuditByCate/index/:cateId',
        component: (callback) => {
            import('./../viewport/supv/taskAudit/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskAuditByCate/index'
    }
    ,
    {
        path: '/supvTaskAuditMulti/index',
        component: (callback) => {
            import('./../viewport/supv/taskAuditMulti/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskAuditMulti/index'
    }
    ,
    {
        path: '/supvTaskAuditMultiByCate/index/:cateId',
        component: (callback) => {
            import('./../viewport/supv/taskAuditMulti/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskAuditMultiByCate/index'
    }
    ,
    {
        path: '/supvTaskEnd/index',
        component: (callback) => {
            import('./../viewport/supv/taskEnd/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskEnd/index'
    }
    ,
    {
        path: '/supvTaskEndByCate/index/:cateId',
        component: (callback) => {
            import('./../viewport/supv/taskEnd/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskEndByCate/index'
    }
    ,
    {
        path: '/supvTask/itemStat/index',
        component: (callback) => {
            import('./../viewport/supv/itemStat/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTask/itemStat/index'
    }
    ,
    {
        path: '/supvTask/itemStatAll/index/:showAll',
        component: (callback) => {
            import('./../viewport/supv/itemStat/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTask/itemStatAll/index/'
    }
    ,
    {
        path: '/supvTask/item/index',
        component: (callback) => {
            import('./../viewport/supv/itemResult/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTask/item/index'
    }
    ,
    {
        path: '/supvTask/itemAll/index/:showAll',
        component: (callback) => {
            import('./../viewport/supv/itemResult/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTask/itemAll/index/'
    }
    ,
    {
        path: '/supvprogress/index',
        component: (callback) => {
            import('./../viewport/supv/progress/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvprogress/index'
    }
    ,
    {
        path: '/supvprogressbyyear/index/:year',
        component: (callback) => {
            import('./../viewport/supv/progress/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvprogressbyyear/index/'
    }
    ,
    {
        path: '/supvprogressview/index',
        component: (callback) => {
            import('./../viewport/supv/progressView/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvprogressview/index'
    }
    ,
    {
        path: '/supvprogressviewbyyear/index/:year',
        component: (callback) => {
            import('./../viewport/supv/progressView/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvprogressviewbyyear/index/'
    }
    ,
    {
        path: '/supvauthorize/index',
        component: (callback) => {
            import('./../viewport/supv/authorize/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvauthorize/index'
    }
    ,
    {
        path: '/supvauthorizebytype/index/:userType',
        component: (callback) => {
            import('./../viewport/supv/authorizebytype/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvauthorizebytype/index/'
    }
    ,
    {
        path: '/supvbudget/index',
        component: (callback) => {
            import('./../viewport/supv/budget/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvbudget/index'
    }
    ,
    {
        path: '/supvExpense/index',
        component: (callback) => {
            import('./../viewport/supv/expenseNew/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvExpense/index'
    }
    ,
    {
        path: '/supvoutlay/index',
        component: (callback) => {
            import('./../viewport/supv/outlay/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvoutlay/index'
    }
    ,
    {
        path: '/supvTask/expense/index',
        component: (callback) => {
            import('./../viewport/supv/expense/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTask/expense/index'
    }
    ,
    {
        path: '/supvtask/progress/index',
        component: (callback) => {
            import('./../viewport/supv/progress/QueryNew').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvtask/progress/index'
    }
    ,
    {
        path: '/supvtask/expense/analysisbyswot',
        component: (callback) => {
            import('./../viewport/supv/expense/AnalysisBySwot').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvtask/expense/analysisbyswot'
    }
    ,
    {
        path: '/supvtask/analysis/analysisbytasknum',
        component: (callback) => {
            import('./../viewport/supv/analysis/AnalysisByTaskNum').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvtask/analysis/analysisbytasknum'
    }
    ,
    {
        path: '/supvtask/analysis/analysisbyfile',
        component: (callback) => {
            import('./../viewport/supv/analysis/analysisbyfile').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvtask/analysis/analysisbyfile'
    }
    ,
    {
        path: '/supvtask/analysis/analysisbyprogress',
        component: (callback) => {
            import('./../viewport/supv/analysis/analysisbyprogress').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvtask/analysis/analysisbyprogress'
    }
    ,
    {
        path: '/supvtask/analysis/analysisbyprogress2',
        component: (callback) => {
            import('./../viewport/supv/analysis/analysisbyprogress2').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvtask/analysis/analysisbyprogress2'
    }
    ,
    {
        path: '/supvTaskDistributeByCate/index/:cateId',
        component: (callback) => {
            import('./../viewport/supv/taskDistribute/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskDistributeByCate/index'
    }
    ,
    {
        path: '/supvTaskDistribute/index',
        component: (callback) => {
            import('./../viewport/supv/taskDistribute/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskDistribute/index'
    }
    ,
    {
        path: '/supvTaskDistributeByCate/ByReplyId/:replyId/:type/:cateId',
        component: (callback) => {
            import('./../viewport/supv/taskDistribute/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskDistributeByCate/ByReplyId/'
    }
    ,
    {
        path: '/supvTaskDistribute/ByReplyId/:replyId/:type',
        component: (callback) => {
            import('./../viewport/supv/taskDistribute/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskDistribute/ByReplyId/'
    }
    ,
    {
        path: '/supvTaskDistributeReplyByCate/index/:cateId',
        component: (callback) => {
            import('./../viewport/supv/taskDistributeReply/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskDistributeReplyByCate/index'
    }
    ,
    {
        path: '/supvTaskDistributeReply/index',
        component: (callback) => {
            import('./../viewport/supv/taskDistributeReply/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskDistributeReply/index'
    }
    ,
    {
        path: '/supvTaskDistributeByCate/replyById/:distributeId/:type/:cateId',
        component: (callback) => {
            import('./../viewport/supv/taskDistributeReply/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskDistributeByCate/replyById/'
    }
    ,
    {
        path: '/supvTaskDistribute/replyById/:distributeId/:type',
        component: (callback) => {
            import('./../viewport/supv/taskDistributeReply/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskDistribute/replyById/'
    }
    ,
    {
        path: '/supv/assign/org/index',
        component: (callback) => {
            import('./../viewport/supv/assignOrg/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supv/assign/org/index'
    }
    ,
    {
        path: '/supvTaskActive/ByReplyId/:replyId/:type',
        component: (callback) => {
            import('./../viewport/supv/taskActive/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/supvTaskActive/ByReplyId/'
    }
    ,
    {
        path: '/academicguidance/studentchooseteacher/index',
        component: (callback) => {
            import('./../viewport/academicGuidance/studentChooseTeacher/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/academicguidance/studentchooseteacher/index'
    }
    ,
    {
        path: '/academicguidance/studentchooseresult/index',
        component: (callback) => {
            import('./../viewport/academicGuidance/studentchooseresult/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/academicguidance/studentchooseresult/index'
    }
    ,
    {
        path: '/academicguidance/studententerprise/index',
        component: (callback) => {
            import('./../viewport/academicGuidance/studententerprise/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/academicguidance/studententerprise/index'
    }
    ,
    {
        path: '/academicguidance/studentconfirm/index',
        component: (callback) => {
            import('./../viewport/academicGuidance/studentconfirm/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/academicguidance/studentconfirm/index'
    }
    ,
    {
        path: '/academicguidance/studentchooseteacherresult/index',
        component: (callback) => {
            import('./../viewport/academicGuidance/studentchooseteacherresult/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/academicguidance/studentchooseteacherresult/index'
    }
    ,
    {
        path: '/academicguidance/teacherconfirm/index',
        component: (callback) => {
            import('./../viewport/academicGuidance/teacherconfirm/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/academicguidance/teacherconfirm/index'
    }
    ,
    {
        path: '/academicguidance/teacherchooseresult/index',
        component: (callback) => {
            import('./../viewport/academicGuidance/teacherchooseresult/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/academicguidance/teacherchooseresult/index'
    }
    ,
    {
        path: '/academicguidance/teacherchoosestudentresult/index',
        component: (callback) => {
            import('./../viewport/academicGuidance/teacherchoosestudentresult/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/academicguidance/teacherchoosestudentresult/index'
    }
    ,
    {
        path: '/academicguidance/teacherstudentallot/index',
        component: (callback) => {
            import('./../viewport/academicGuidance/teacherstudentallot/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/academicguidance/teacherstudentallot/index'
    }
    ,
    {
        path: '/academicguidance/teacherchoosestudent/index',
        component: (callback) => {
            import('./../viewport/academicGuidance/teacherchoosestudent/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/academicguidance/teacherchoosestudent/index'
    }
    ,
    {
        path: '/academicguidance/teacherstudentallot2/index',
        component: (callback) => {
            import('./../viewport/academicGuidance/teacherstudentallot2/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/academicguidance/teacherstudentallot2/index'
    }
    ,
    {
        path: '/academicguidance/industryanalysis/index',
        component: (callback) => {
            import('./../viewport/academicGuidance/industryanalysis/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/academicguidance/industryanalysis/index'
    }
    ,
    {
        path: '/academicguidance/enterpriseanalysis/index',
        component: (callback) => {
            import('./../viewport/academicGuidance/enterpriseanalysis/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/academicguidance/enterpriseanalysis/index'
    }
    ,
    {
        path: '/academicguidance/analysissalarybyorg/index',
        component: (callback) => {
            import('./../viewport/academicGuidance/analysissalarybyorg/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/academicguidance/analysissalarybyorg/index'
    }
    ,
    {
        path: '/academicguidance/professional/counterpart/analysis/index',
        component: (callback) => {
            import('./../viewport/academicGuidance/professionalCounterpartAnalysis/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/academicguidance/professional/counterpart/analysis/index'
    }
    ,
    {
        path: '/academicguidance/analysissalarybyswot/index',
        component: (callback) => {
            import('./../viewport/academicGuidance/analysisSalaryBySwot/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/academicguidance/analysissalarybyswot/index'
    }
    ,
    {
        path: '/academicguidance/enterpriseinfo/index',
        component: (callback) => {
            import('./../viewport/academicGuidance/enterpriseinfo/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/academicguidance/enterpriseinfo/index'
    }
    ,
    {
        path: '/assessment/evaluation/term/index',
        component: (callback) => {
            import('./../viewport/assessmentEvaluation/term/TermQuery').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/assessment/evaluation/term/index'
    }
    ,
    {
        path: '/assessment/evaluation/term/dudao',
        component: (callback) => {
            import('./../viewport/assessmentEvaluation/term/DudaoTermQuery').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/assessment/evaluation/term/dudao'
    }
    ,
    {
        path: '/assessment/evaluation/year/index',
        component: (callback) => {
            import('./../viewport/assessmentEvaluation/year/YearQuery').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/assessment/evaluation/year/index'
    }
    ,
    {
        path: '/assessment/evaluation/year/index',
        component: (callback) => {
            import('./../viewport/assessmentEvaluation/year/DudaoYearQuery').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/assessment/evaluation/year/index'
    }
    ,
    {
        path: '/dataImport/index',
        component: (callback) => {
            import('./../viewport/dataImport/resultData/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dataImport/index'
    }
    ,
    {
        path: '/eval/result/analysis/list/:itemId',
        component: (callback) => {
            import('./../viewport/reports/analysis/list/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/analysis/list/'
    }
    ,
    {
        path: '/eval/result/analysis/year/:itemId',
        component: (callback) => {
            import('./../viewport/reports/analysis/year/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/analysis/year/'
    }
    ,
    {
        path: '/eval/result/analysis/swot',
        component: (callback) => {
            import('./../viewport/reports/analysis/swot/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/analysis/swot'
    }
    ,
    {
        path: '/eval/result/analysis/term/:itemId',
        component: (callback) => {
            import('./../viewport/reports/analysis/term/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/analysis/term/'
    }
    ,
    {
        path: '/eval/result/analysis/multi/conditions',
        component: (callback) => {
            import('./../viewport/reports/analysis/upSwot/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/analysis/multi/conditions'
    }
    ,
    {
        path: '/teacherqualityreport/index',
        component: (callback) => {
            import('./../viewport/teacherQualityReport/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherqualityreport/index'
    }
    ,
    {
        path: '/eval/result/analysis/correlation',
        component: (callback) => {
            import('./../viewport/reports/analysis/correlationAnalysis/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/analysis/correlation'
    }
    ,
    {
        path: '/eval/result/analysis/regression',
        component: (callback) => {
            import('./../viewport/reports/analysis/regression/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/analysis/regression'
    }
    ,
    {
        path: '/targetconfig/query',
        component: (callback) => {
            import('./../viewport/targetConfig/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/targetconfig/query'
    }
    ,
    {
        path: '/ky/project/portrait/index',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/portrait/manage/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/portrait/index'
    }
    ,
    {
        path: '/ky/project/portrait/init/department/examine',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/portrait/manage/DepartmentExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/portrait/init/department/examine'
    }
    ,
    {
        path: '/ky/project/portrait/init/school/examine',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/portrait/manage/SchoolExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/portrait/init/school/examine'
    }
    ,
    {
        path: '/ky/project/portrait/alteration/index',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/portrait/alteration/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/portrait/alteration/index'
    }
    ,
    {
        path: '/ky/project/portrait/alteration/school/examine',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/portrait/alteration/SchoolExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/portrait/alteration/school/examine'
    }
    ,
    {
        path: '/ky/home',
        component: (callback) => {
            import('./../viewport/scientificResearch/home').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/home'
    }
    ,
    {
        path: '/ky/project/portrait/complete/index',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/portrait/complete/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/portrait/complete/index'
    }
    ,
    {
        path: '/ky/project/portrait/complete/examine',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/portrait/complete/SchoolExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/portrait/complete/examine'
    }
    ,
    {
        path: '/ky/project/transverse/sign/index',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/transverse/sign/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/transverse/sign/index'
    }
    ,
    {
        path: '/ky/project/transverse/sign/department/examine',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/transverse/sign/DepartmentExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/transverse/sign/department/examine'
    }
    ,
    {
        path: '/ky/project/transverse/sign/school/examine',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/transverse/sign/SchoolExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/transverse/sign/school/examine'
    }
    ,
    {
        path: '/ky/base/budget/standard/index',
        component: (callback) => {
            import('./../viewport/scientificResearch/baseManage/budgetStandard/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/base/budget/standard/index'
    }
    ,
    {
        path: '/ky/project/setting/type/index',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/setting/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/setting/type/index'
    }
    ,
    {
        path: '/ky/project/portrait/alteration/department/examine',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/portrait/alteration/DepartmentExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/portrait/alteration/department/examine'
    }
    ,
    {
        path: '/ky/project/portrait/complete/department/examine',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/portrait/complete/DepartmentExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/portrait/complete/department/examine'
    }
    ,
    {
        path: '/ky/project/transverse/filings/index',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/transverse/filings/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/transverse/filings/index'
    }
    ,
    {
        path: '/ky/project/transverse/init/department/examine',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/transverse/filings/DepartmentExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/transverse/init/department/examine'
    }
    ,
    {
        path: '/ky/project/transverse/init/school/examine',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/transverse/filings/SchoolExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/transverse/init/school/examine'
    }
    ,
    {
        path: '/ky/project/transverse/alteration/index',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/transverse/alteration/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/transverse/alteration/index'
    }
    ,
    {
        path: '/ky/project/transverse/alteration/department/examine',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/transverse/alteration/DepartmentExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/transverse/alteration/department/examine'
    }
    ,
    {
        path: '/ky/project/transverse/alteration/school/examine',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/transverse/alteration/SchoolExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/transverse/alteration/school/examine'
    }
    ,
    {
        path: '/ky/project/transverse/complete/index',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/transverse/complete/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/transverse/complete/index'
    }
    ,
    {
        path: '/ky/project/transverse/complete/department/examine',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/transverse/complete/DepartmentExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/transverse/complete/department/examine'
    }
    ,
    {
        path: '/ky/project/transverse/complete/school/examine',
        component: (callback) => {
            import('./../viewport/scientificResearch/projectManage/transverse/complete/SchoolExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/transverse/complete/school/examine'
    }
    ,
    {
        path: '/ky/base/attribution/source/index',
        component: (callback) => {
            import('./../viewport/scientificResearch/baseManage/attribution/projectSource/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/base/attribution/source/index'
    }
    ,
    {
        path: '/ky/base/attribution/subject/index',
        component: (callback) => {
            import('./../viewport/scientificResearch/baseManage/attribution/subject/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/base/attribution/subject/index'
    }
    ,
    {
        path: '/ky/base/attribution/social/economy/index',
        component: (callback) => {
            import('./../viewport/scientificResearch/baseManage/attribution/socioEconomic/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/base/attribution/social/economy/index'
    }
    ,
    {
        path: '/ky/base/attribution/national/economy/index',
        component: (callback) => {
            import('./../viewport/scientificResearch/baseManage/attribution/nationalEconomy/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/base/attribution/national/economy/index'
    }
    ,
    {
        path: '/teacherteachingquality/coursescore',
        component: (callback) => {
            import('./../viewport/teacherTeachingQuality/CourseScore/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherteachingquality/coursescore'
    }
    ,
    {
        path: '/teacherteachingquality/thesisearlier',
        component: (callback) => {
            import('./../viewport/teacherTeachingQuality/ThesisEarlier/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherteachingquality/thesisearlier'
    }
    ,
    {
        path: '/teacherteachingquality/thesisschoolexcellen',
        component: (callback) => {
            import('./../viewport/teacherTeachingQuality/ThesisSchoolExcellent/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherteachingquality/thesisschoolexcellen'
    }
    ,
    {
        path: '/teacherteachingquality/thesisprovinceexcellent',
        component: (callback) => {
            import('./../viewport/teacherTeachingQuality/ThesisProvinceExcellent/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherteachingquality/thesisprovinceexcellent'
    }
    ,
    {
        path: '/teacherteachingquality/examinspect',
        component: (callback) => {
            import('./../viewport/teacherTeachingQuality/ExamInspect/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherteachingquality/examinspect'
    }
    ,
    {
        path: '/teacherteachingquality/schoolsupervisor',
        component: (callback) => {
            import('./../viewport/teacherTeachingQuality/SchoolSupervisor/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherteachingquality/schoolsupervisor'
    }
    ,
    {
        path: '/teacherteachingquality/teacherweightedscore/index',
        component: (callback) => {
            import('./../viewport/teacherTeachingQuality/TeacherWeightedScore/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherteachingquality/teacherweightedscore/index'
    }
    ,
    {
        path: '/teacherteachingquality/thesisinspection/index',
        component: (callback) => {
            import('./../viewport/teacherTeachingQuality/ThesisInspection/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherteachingquality/thesisinspection/index'
    }
    ,
    {
        path: '/teacherteachingquality/thesisreplyearlier/index',
        component: (callback) => {
            import('./../viewport/teacherTeachingQuality/ThesisReplyEarlier/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherteachingquality/thesisreplyearlier/index'
    }
    ,
    {
        path: '/teacherteachingquality/thesisreply/index',
        component: (callback) => {
            import('./../viewport/teacherTeachingQuality/ThesisReply/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherteachingquality/thesisreply/index'
    }
    ,
    {
        path: '/teacherteachingquality/thesiscomprehensive/index',
        component: (callback) => {
            import('./../viewport/teacherTeachingQuality/ThesisComprehensive/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherteachingquality/thesiscomprehensive/index'
    }
    ,
    {
        path: '/teacherteachingquality/provincialrandominspection/index',
        component: (callback) => {
            import('./../viewport/teacherTeachingQuality/ProvincialRandomInspection/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherteachingquality/provincialrandominspection/index'
    }
    ,
    {
        path: '/teacherteachingquality/teachingaccident/index',
        component: (callback) => {
            import('./../viewport/teacherTeachingQuality/TeachingAccident/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherteachingquality/teachingaccident/index'
    }
    ,
    {
        path: '/teacherteachingquality/dataimport',
        component: (callback) => {
            import('./../viewport/teacherTeachingQuality/DataImport/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherteachingquality/dataimport'
    }
    ,
    {
        path: '/teacherteachingquality/peereval',
        component: (callback) => {
            import('./../viewport/teacherTeachingQuality/PeerEval/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherteachingquality/peereval'
    }
    ,
    {
        path: '/teacherteachingquality/collect',
        component: (callback) => {
            import('./../viewport/teacherTeachingQuality/Collect/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherteachingquality/collect'
    },
    {
        path: '/ky/base/achievement/magazine/source/index',
        component: (callback) => {
            import('../viewport/scientificResearch/baseManage/achievement/magazineSource/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/base/achievement/magazine/source/index/',
    },
    {
        path: '/ky/base/achievement/magazine/index',
        component: (callback) => {
            import('../viewport/scientificResearch/baseManage/achievement/magazine/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/base/achievement/magazine/index/',
    },
    {
        path: '/ky/base/achievement/magazine/byid/:magazineSourceId',
        component: (callback) => {
            import('../viewport/scientificResearch/baseManage/achievement/magazine/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/base/achievement/magazine/byid/',
    },
    {
        path: '/ky/base/achievement/paper/level/index',
        component: (callback) => {
            import('../viewport/scientificResearch/baseManage/achievement/paperLevel/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/base/achievement/paper/level/index/',
    },
    {
        path: '/ky/achievement/paper/index',
        component: (callback) => {
            import('../viewport/scientificResearch/achievement/paper/manage/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/achievement/paper/index/',
    },
    {
        path: '/ky/achievement/paper/examine/department/index',
        component: (callback) => {
            import('../viewport/scientificResearch/achievement/paper/manage/DepartmentExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/achievement/paper/examine/department/index/',
    },
    {
        path: '/ky/achievement/paper/examine/school/index',
        component: (callback) => {
            import('../viewport/scientificResearch/achievement/paper/manage/SchoolExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/achievement/paper/examine/school/index/',
    },
    {
        path: '/ky/achievement/book/index',
        component: (callback) => {
            import('../viewport/scientificResearch/achievement/book/manage/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/achievement/book/index/',
    },
    {
        path: '/ky/achievement/book/examine/department/index',
        component: (callback) => {
            import('../viewport/scientificResearch/achievement/book/manage/DepartmentExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/achievement/book/examine/department/index/',
    },
    {
        path: '/ky/achievement/book/examine/school/index',
        component: (callback) => {
            import('../viewport/scientificResearch/achievement/book/manage/SchoolExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/achievement/book/examine/school/index/',
    },
    {
        path: '/ky/achievement/report/index',
        component: (callback) => {
            import('../viewport/scientificResearch/achievement/researchReport/manage/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/achievement/report/index/',
    },
    {
        path: '/ky/achievement/report/examine/department/index',
        component: (callback) => {
            import('../viewport/scientificResearch/achievement/researchReport/manage/DepartmentExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/achievement/report/examine/department/index/',
    },
    {
        path: '/ky/achievement/report/examine/school/index',
        component: (callback) => {
            import('../viewport/scientificResearch/achievement/researchReport/manage/SchoolExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/achievement/report/examine/school/index/',
    },

    {
        path: '/ky/achievement/art/index',
        component: (callback) => {
            import('../viewport/scientificResearch/achievement/artProduct/manage/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/achievement/art/index/',
    },
    {
        path: '/ky/achievement/art/examine/department/index',
        component: (callback) => {
            import('../viewport/scientificResearch/achievement/artProduct/manage/DepartmentExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/achievement/art/examine/department/index/',
    },
    {
        path: '/ky/achievement/art/examine/school/index',
        component: (callback) => {
            import('../viewport/scientificResearch/achievement/artProduct/manage/SchoolExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/achievement/art/examine/school/index/',
    },

    {
        path: '/ky/achievement/copyright/index',
        component: (callback) => {
            import('../viewport/scientificResearch/achievement/copyright/manage/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/achievement/copyright/index/',
    },
    {
        path: '/ky/achievement/copyright/examine/department/index',
        component: (callback) => {
            import('../viewport/scientificResearch/achievement/copyright/manage/DepartmentExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/achievement/copyright/examine/department/index/',
    },
    {
        path: '/ky/achievement/copyright/examine/school/index',
        component: (callback) => {
            import('../viewport/scientificResearch/achievement/copyright/manage/SchoolExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/achievement/copyright/examine/school/index/',
    },

    {
        path: '/ky/achievement/patent/index',
        component: (callback) => {
            import('../viewport/scientificResearch/achievement/patent/manage/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/achievement/patent/index/',
    },
    {
        path: '/ky/achievement/patent/examine/department/index',
        component: (callback) => {
            import('../viewport/scientificResearch/achievement/patent/manage/DepartmentExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/achievement/patent/examine/department/index/',
    },
    {
        path: '/ky/achievement/patent/examine/school/index',
        component: (callback) => {
            import('../viewport/scientificResearch/achievement/patent/manage/SchoolExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/achievement/patent/examine/school/index/',
    },

    {
        path: '/ky/achievement/honor/index',
        component: (callback) => {
            import('../viewport/scientificResearch/achievement/honor/manage/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/achievement/honor/index/',
    },
    {
        path: '/ky/achievement/honor/examine/department/index',
        component: (callback) => {
            import('../viewport/scientificResearch/achievement/honor/manage/DepartmentExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/achievement/honor/examine/department/index/',
    },
    {
        path: '/ky/achievement/honor/examine/school/index',
        component: (callback) => {
            import('../viewport/scientificResearch/achievement/honor/manage/SchoolExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/achievement/honor/examine/school/index/',
    },
    {
        path: '/ky/project/school/index',
        component: (callback) => {
            import('../viewport/scientificResearch/projectManage/schoolProject/manage/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/school/index/',
    },
    {
        path: '/ky/project/school/init/department/examine',
        component: (callback) => {
            import('../viewport/scientificResearch/projectManage/schoolProject/manage/DepartmentExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/school/init/department/examine/',
    },
    {
        path: '/ky/project/school/init/school/examine',
        component: (callback) => {
            import('../viewport/scientificResearch/projectManage/schoolProject/manage/SchoolExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/school/init/school/examine/',
    },
    {
        path: '/ky/project/school/alteration/index',
        component: (callback) => {
            import('../viewport/scientificResearch/projectManage/schoolProject/alteration/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/school/alteration/index/',
    },
    {
        path: '/ky/project/school/alteration/school/examine',
        component: (callback) => {
            import('../viewport/scientificResearch/projectManage/schoolProject/alteration/SchoolExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/school/alteration/school/examine/',
    },
    {
        path: '/ky/project/school/complete/index',
        component: (callback) => {
            import('../viewport/scientificResearch/projectManage/schoolProject/complete/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/school/complete/index/',
    },

    {
        path: '/ky/project/school/complete/department/examine',
        component: (callback) => {
            import('../viewport/scientificResearch/projectManage/schoolProject/alteration/DepartmentExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/school/complete/department/examine/',
    },
    {
        path: '/ky/project/school/complete/school/examine',
        component: (callback) => {
            import('../viewport/scientificResearch/projectManage/schoolProject/complete/SchoolExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/school/complete/school/examine/',
    },
    {
        path: '/ky/project/school/inspect/index',
        component: (callback) => {
            import('../viewport/scientificResearch/projectManage/schoolProject/inspect/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/school/inspect/index/',
    },
    {
        path: '/ky/project/school/inspect/department/examine',
        component: (callback) => {
            import('../viewport/scientificResearch/projectManage/schoolProject/inspect/DepartmentExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/school/inspect/department/examine/',
    },
    {
        path: '/ky/project/school/inspect/school/examine',
        component: (callback) => {
            import('../viewport/scientificResearch/projectManage/schoolProject/inspect/SchoolExamine').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/school/inspect/school/examine/',
    },

    {
        path: '/ky/project/apply/index',
        component: (callback) => {
            import('../viewport/scientificResearch/projectManage/applyProject/applyPlan/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ky/project/apply/index/',
    },
    {
        path: '/eval/result/analysis/complex/regression',
        component: (callback) => {
            import('./../viewport/reports/analysis/regression/ComplexRegression').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/analysis/complex/regression'
    }
    ,
    {
        path: '/eval/org/data/query',
        component: (callback) => {
            import('./../viewport/dataStatistics/import/orgData/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/org/data/query'
    }
    ,
    {
        path: '/eval/dudao/data/query',
        component: (callback) => {
            import('./../viewport/dataStatistics/import/dudaoData/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/dudao/data/query'
    }
    ,
    {
        path: '/eval/stu/data/query',
        component: (callback) => {
            import('../viewport/dataStatistics/import/stuData/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/stu/data/query'
    }
    ,
    {
        path: '/eval/outstand/data/query',
        component: (callback) => {
            import('../viewport/dataStatistics/import/outStandList/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/outstand/data/query'
    }
    ,
    {
        path: '/eval/org/data/view',
        component: (callback) => {
            import('./../viewport/dataStatistics/view/orgData/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/org/data/view'
    }
    ,
    {
        path: '/eval/dudao/data/view',
        component: (callback) => {
            import('./../viewport/dataStatistics/view/dudaoData/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/dudao/data/view'
    }
    ,
    {
        path: '/eval/stu/data/view',
        component: (callback) => {
            import('../viewport/dataStatistics/view/stuData/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/stu/data/view'
    }
    ,
    {
        path: '/eval/outstand/data/view',
        component: (callback) => {
            import('../viewport/dataStatistics/view/outStandList/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/outstand/data/view'
    }
    ,
    {
        path: '/eval/total/data/view',
        component: (callback) => {
            import('../viewport/dataStatistics/statistics/total/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/total/data/view'
    }
    ,
    {
        path: '/eval/outStandStat/data/view',
        component: (callback) => {
            import('../viewport/dataStatistics/statistics/outStandStat/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/outStandStat/data/view'
    }
    ,
    {
        path: '/eval/summary/data/view',
        component: (callback) => {
            import('../viewport/dataStatistics/statistics/summary/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/summary/data/view'
    }
    ,
    {
        path: '/eval/outStandTotal/data/view',
        component: (callback) => {
            import('../viewport/dataStatistics/statistics/outStandTotal/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/outStandTotal/data/view'
    }
    ,
    {
        path: '/eval/twoBestTotal/data/view',
        component: (callback) => {
            import('../viewport/dataStatistics/statistics/twoBestTotal/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/twoBestTotal/data/view'
    }
    ,
    {
        path: '/eval/gradeTotal/data/view',
        component: (callback) => {
            import('../viewport/dataStatistics/statistics/gradeTotal/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/gradeTotal/data/view'
    },
    {
        path: '/message/student/send',
        component: (callback) => {
            import('../viewport/message/send/student/Student').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/message/student/send'
    }
    ,
    {
        path: '/message/teacher/send',
        component: (callback) => {
            import('../viewport/message/send/teacher/Teacher').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/message/teacher/send'
    }
    ,
    {
        path: '/message/report/total',
        component: (callback) => {
            import('../viewport/message/report/total/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/message/report/total'
    }
    ,
    {
        path: '/plan/listen/course/selection/index',
        component: (callback) => {
            import('./../viewport/plans/listenTaskManage/courseSelection/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/plan/listen/course/selection/index/'
    }
    ,
    {
        path: '/plan/listen/course/task/index',
        component: (callback) => {
            import('./../viewport/plans/listenTaskManage/listenTask/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/plan/listen/course/task/index/'
    }
    ,
    {
        path: '/plan/listen/course/task/selection/index',
        component: (callback) => {
            import('../viewport/plans/listenTaskManage/listenTask/TaskSelection').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/plan/listen/course/task/selection/index/'
    }
    ,
    {
        path: '/plan/listen/course/task/attend/lecture',
        component: (callback) => {
            import('../viewport/plans/listenTaskManage/listenTask/AttendLecture').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/plan/listen/course/task/attend/lecture/'
    }
    ,
    {
        path: '/plan/listen/course/task/eval/inputs/:itemId/:itemPid/:id',
        component: (callback) => {
            import('./../viewport/plans/listenTaskManage/evalInput/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/plan/listen/course/task/eval/inputs/'
    }
    ,
    {
        path: '/plan/listen/course/task/eval/send/message',
        component: (callback) => {
            import('./../viewport/plans/listenTaskManage/sendMessage/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/plan/listen/course/task/eval/send/message/'
    },
    {
        path: '/along/class/publish/query',
        component: (callback) => {
            import('./../viewport/alongClass/publish/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/along/class/publish/query'
    },
    {
        path: '/along/class/result/query',
        component: (callback) => {
            import('./../viewport/alongClass/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/along/class/result/query'
    },
    {
        path: '/plan/listen/course/task/overview',
        component: (callback) => {
            import('./../viewport/plans/listenTaskManage/listenTask/overviewCourseSelection/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/plan/listen/course/task/overview/'
    },
    {
        path: '/plan/listen/calendar/index',
        component: (callback) => {
            import('./../viewport/plans/listenTaskManage/schoolCalendar/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/plan/listen/calendar/index'
    },
    {
        path: '/plan/calendar/index',
        component: (callback) => {
            import('./../viewport/plans/schoolCalendar/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/plan/calendar/index'
    },
    {
        path: '/secondcredit/teacherpublish/index',
        component: (callback) => {
            import('./../viewport/secondCredit/teacherPublish/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/secondCredit/teacherPublish/index'

    },
    {
        path: '/dtme/target/index',
        component: (callback) => {
            import('./../viewport/dtme/target/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dtme/target/index'

    },
    {
        path: '/dtme/assign/index/:type',
        component: (callback) => {
            import('./../viewport/dtme/assign/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dtme/assign/index'

    },
    {
        path: '/dtme/result/enter/:targetId/:orgId',
        component: (callback) => {
            import('./../viewport/dtme/result/Enter').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dtme/result/enter'

    },
    {
        path: '/dtme/result/enter2/:targetId/:orgId',
        component: (callback) => {
            import('./../viewport/dtme/result/Enter2').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dtme/result/enter2'

    },
    {
        path: '/dtme/result/enterindex/:targetId',
        component: (callback) => {
            import('./../viewport/dtme/result/EnterIndex').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dtme/result/enterindex'

    },
    {
        path: '/dtme/result/enter2index/:targetId',
        component: (callback) => {
            import('./../viewport/dtme/result/Enter2Index').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dtme/result/enter2index'

    },
    {
        path: '/dtme/result/index/:type',
        component: (callback) => {
            import('./../viewport/dtme/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dtme/result/index'

    },
    {
        path: '/grade/summary/list/index',
        component: (callback) => {
            import('../viewport/grade/list/Query').then((Products) => {
                callback(Products.default)
            })
        },
        name: '/grade/summary/list/index',
    },

    {
        path: '/grade/summary/org/index',
        component: (callback) => {
            import('../viewport/grade/summary/orgSummary/Query').then((Products) => {
                callback(Products.default)
            })
        },
        name: '/grade/summary/org/index',
    },
    {
        path: '/grade/summary/external/index',
        component: (callback) => {
            import('../viewport/grade/summary/externalSummary/Query').then((Products) => {
                callback(Products.default)
            })
        },
        name: '/grade/summary/external/index',
    },

    {
        path: '/gradesummayimport/index',
        component: (callback) => {
            import('../viewport/gradeSummaryImport/Query').then((Products) => {
                callback(Products.default)
            })
        },
        name: '/gradesummayimport/index',
    },
    {
        path: '/datasync/index',
        component: (callback) => {
            import('../viewport/dataSync/Query').then((Products) => {
                callback(Products.default)
            })
        },
        name: '/datasync/index',
    },
    {
        path: '/messagechat/index',
        component: (callback) => {
            import('../viewport/messageChat/Query').then((Products) => {
                callback(Products.default)
            })
        },
        name: '/messagechat/index',
    },
    {
        path: '/teacherQualitySummary/index',
        component: (callback) => {
            import('../viewport/teacherQualitySummary/Query').then((Products) => {
                callback(Products.default)
            })
        },
        name: '/teacherQualitySummary/index',
    }
    ,
    {
        path: '/teacherQualitySummary/import',
        component: (callback) => {
            import('../viewport/teacherQualitySummary/Import').then((Products) => {
                callback(Products.default)
            })
        },
        name: '/teacherQualitySummary/import',
    }
    ,
    {
        path: '/teacherQualitySummary/importResult',
        component: (callback) => {
            import('../viewport/teacherQualitySummary/ImportResult').then((Products) => {
                callback(Products.default)
            })
        },
        name: '/teacherQualitySummary/importResult',
    }
    ,
    {
        path: '/zgxycp/analysis/scientific/swot/index/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/analysis/scientificAnalysis/swot/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/analysis/scientific/swot/index'
    }
    ,
    {
        path: '/zgxycp/analysis/scientific/correlation/:objectType',
        component: (callback) => {
            import('./../viewport/zgxycp/analysis/scientificAnalysis/correlationAnalysis/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgxycp/analysis/scientific/correlation'
    }
    ,
    {
        path: '/graduation/form/Entring/input/:id',
        component: (callback) => {
            import('../viewport/graduation/formEntring/input/index').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/form/Entring/input'
    }
    ,
    {
        path: '/graduation/form/Entring/result/:id',
        component: (callback) => {
            import('../viewport/graduation/formEntring/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/form/Entring/result'
    }
    ,
    {
        path: '/graduation/form/audit/assign/:type',
        component: (callback) => {
            import('./../viewport/graduation/formEntring/assign/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/form/audit/assign/'
    }
    ,
    {
        path: '/graduation/form/audit1/:id',
        component: (callback) => {
            import('../viewport/graduation/formEntring/audit1/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/form/audit1'
    }
    ,
    {
        path: '/graduation/form/result/audit1/:id',
        component: (callback) => {
            import('../viewport/graduation/formEntring/audit1/Result').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/form/result/audit1'
    }
    ,
    {
        path: '/graduation/form/audit2/:id',
        component: (callback) => {
            import('../viewport/graduation/formEntring/audit2/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/form/audit2'
    }
    ,
    {
        path: '/graduation/form/result/audit2/:id',
        component: (callback) => {
            import('../viewport/graduation/formEntring/audit2/Result').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/form/result/audit2'
    }
    ,
    {
        path: '/graduation/form/audit3/:id',
        component: (callback) => {
            import('../viewport/graduation/formEntring/audit3/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/form/audit3'
    }
    ,
    {
        path: '/graduation/form/result/audit3/:id',
        component: (callback) => {
            import('../viewport/graduation/formEntring/audit3/Result').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/form/result/audit3'
    }
    ,
    {
        path: '/graduation/form/Entring/audit1/:id/:v',
        component: (callback) => {
            import('../viewport/graduation/formEntring/audit1/audit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/form/Entring/audit1'
    }
    ,
    {
        path: '/graduation/form/Entring/audit2/:id/:v',
        component: (callback) => {
            import('../viewport/graduation/formEntring/audit2/audit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/form/Entring/audit2'
    }
    ,
    {
        path: '/graduation/form/Entring/audit3/:id/:v',
        component: (callback) => {
            import('../viewport/graduation/formEntring/audit3/audit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/form/Entring/audit3'
    }
    ,
    {
        path: '/graduation/form/Entring/edit/:id/:v',
        component: (callback) => {
            import('../viewport/graduation/formEntring/input/edit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/form/Entring/edit'
    }
    ,
    {
        path: '/graduation/form/Entring/detail/:id/:v',
        component: (callback) => {
            import('../viewport/graduation/formEntring/input/detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/graduation/form/Entring/detail'
    }
    ,
    {
        path: '/eval/result/total/evaluator/:itemId',
        component: (callback) => {
            import('./../viewport/reports/totalForEvaluator/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/total/evaluator/'
    }
    ,
    {
        path: '/eval/result/totalClassAll/index',
        component: (callback) => {
            import('./../viewport/reports/totalClass/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/totalClassAll/index'
    }
    ,
    {
        path: '/eval/result/totalClass/index/:id',
        component: (callback) => {
            import('./../viewport/reports/totalClass/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/totalClass/index'
    }
    ,
    {
        path: '/ods/teaching/quality/evaluation/',
        component: (callback) => {
            import('./../viewport/ods/teachingQualityEvaluation/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ods/teaching/quality/evaluation/'
    }
    ,
    {
        path: '/ods/inspection/course/',
        component: (callback) => {
            import('./../viewport/ods/inspectionCourse/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/ods/inspection/course/'
    },
    {
        path: '/eval/result/collect/rank/query',
        component: (callback) => {
            import('./../viewport/evalCollectRank/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/collect/rank/query'
    },
    {
        path: '/eval/result/collect/rank/import/query',
        component: (callback) => {
            import('./../viewport/evalCollectRank/import/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/collect/rank/import/query'
    },
    {
        path: '/eval/result/collect/rank/assignByOrg/index',
        component: (callback) => {
            import('./../viewport/evalCollectRank/assignByOrg/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/collect/rank/assignByOrg/query'
    },
    {
        path: '/evaldatasummary/index',
        component: (callback) => {
            import('../viewport/evalDataSummary/Query').then((Products) => {
                callback(Products.default)
            })
        },
        name: '/evaldatasummary/index',
    },
    {
        path: '/schoolcalendarimport/index',
        component: (callback) => {
            import('../viewport/plans/listenTaskManage/schoolCalendarImport/Query').then((Products) => {
                callback(Products.default)
            })
        },
        name: '/schoolcalendarimport/index',
    },
    {
        path: '/teacherteachingqualityreport/index',
        component: (callback) => {
            import('./../viewport/teacherTeachingQualityReport/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherteachingqualityreport/index'
    }
    ,
    {
        path: '/evalSurvey/common/correlation',
        component: (callback) => {
            import('./../viewport/evalSurvey/common/correlationAnalysis/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/common/correlation'
    }
    ,
    {
        path: '/evalSurvey/common/analysis/regression',
        component: (callback) => {
            import('./../viewport/evalSurvey/common/regression/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalSurvey/common/analysis/regression'
    }
    ,
    {
        path: '/dossier/org/index',
        component: (callback) => {
            import('./../viewport/dossier/basic/org/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dossier/org/index'
    }
    ,
    {
        path: '/dossier/dictionary/index',
        component: (callback) => {
            import('./../viewport/dossier/basic/dictionary/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dossier/dictionary/index'
    }
    ,
    {
        path: '/dossier/param/index',
        component: (callback) => {
            import('./../viewport/dossier/basic/param/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dossier/param/index'
    }
    ,
    {
        path: '/dossier/check/template',
        component: (callback) => {
            import('./../viewport/dossier/basic/template/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dossier/check/template'
    }
    ,
    {
        path: '/dossier/folder/index',
        component: (callback) => {
            import('./../viewport/dossier/basic/folder/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dossier/folder/index'
    }
    ,
    {
        path: '/dossier/folder/auth/index',
        component: (callback) => {
            import('./../viewport/dossier/basic/auth/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dossier/folder/auth/index'
    }
    ,
    {
        path: '/dossier/org/auth/index',
        component: (callback) => {
            import('./../viewport/dossier/basic/authorg/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dossier/org/auth/index'
    }
    ,
    {
        path: '/dossier/file/index',
        component: (callback) => {
            import('./../viewport/dossier/file/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dossier/file/index'
    }
    ,
    {
        path: '/dossier/analysis/analysisbyfile',
        component: (callback) => {
            import('./../viewport/dossier/analysis/analysisbyfile').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dossier/analysis/analysisbyfile'
    },
    {
        path: '/teacherteachingquality/orgauth',
        component: (callback) => {
            import('./../viewport/teacherTeachingQuality/orgAuth/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/teacherteachingquality/orgauth'
    },
    {
        path: '/zgcp/result/evaluation/score',
        component: (callback) => {
            import('./../viewport/zgcp/evaluationScore/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/zgcp/result/evaluation/score'
    }
    ,
    {
        path: '/dossier/file/view/index',
        component: (callback) => {
            import('./../viewport/dossier/view/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dossier/file/view/index'
    }
    ,
    {
        path: '/dossier/file/download/index',
        component: (callback) => {
            import('./../viewport/dossier/download/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dossier/file/download/index'
    }
    ,
    {
        path: '/dossier/template/file/index',
        component: (callback) => {
            import('./../viewport/dossier/data/dataImport/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dossier/template/file/index'
    }
    ,
    {
        path: '/dossier/import/dataView/index',
        component: (callback) => {
            import('./../viewport/dossier/data/dataView/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dossier/import/dataView/index'
    }
    ,
    {
        path: '/dossier/import/dataEdit/index',
        component: (callback) => {
            import('./../viewport/dossier/data/dataEdit/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dossier/import/dataEdit/index'
    }
    ,
    {
        path: '/dossier/file/dataDownload/index',
        component: (callback) => {
            import('./../viewport/dossier/data/dataDownload/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dossier/file/dataDownload/index'
    }
    ,
    {
        path: '/dossier/file/dataDownloadSelf/index',
        component: (callback) => {
            import('./../viewport/dossier/data/dataDownload/QuerySelf').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dossier/file/dataDownloadSelf/index'
    }
    ,
    {
        path: '/eval/result/comments/wordcount/:itemId',
        component: (callback) => {
            import('./../viewport/reports/comments/commentWordCount').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/comments/wordcount/'
    }
    ,
    {
        path: '/plan/listen/course/task/new/:itemId',
        component: (callback) => {
            import('./../viewport/plans/listenTaskManage/listenTask/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/plan/listen/course/task/new/'
    },
    {
        path: '/classroom/certification/analysis/view',
        component: (callback) => {
            import('./../viewport/analysis/classroomCertificationAnalysis/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/classroom/certification/analysis/view'
    }
    ,
    {
        path: '/datav/config/teachquality/index',
        component: (callback) => {
            import('../viewport/dataVConfig/teachingQuality/dataVConfig').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/datav/config/teachquality/index'
    }
    ,
    {
        path: '/datav/config/effective/class/index',
        component: (callback) => {
            import('../viewport/dataVConfig/effectiveClass/dataVConfig').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/datav/config/effective/class/index'
    }
    ,
    {
        path: '/datav/config/supervision/eval/index',
        component: (callback) => {
            import('../viewport/dataVConfig/supervisionEval/dataVConfig').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/datav/config/supervision/eval/index'
    }
    ,
    {
        path: '/evalanalysis/orgauth',
        component: (callback) => {
            import('./../viewport/evalAnalysisOrgAuth/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/evalanalysis/orgauth'
    },
    {
        path: '/datav/config/course/manage/eval/index',
        component: (callback) => {
            import('../viewport/dataVConfig/courseManageEval/dataVConfig').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/datav/config/course/manage/eval/index'
    },
    ,
    {
        path: '/jxcpReport/index',
        component: (callback) => {
            import('./../viewport/jxcpReport/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/jxcpReport/index'
    }
    ,
    {
        path: '/jxcpReportTerm/index',
        component: (callback) => {
            import('./../viewport/jxcpReportTerm/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/jxcpReportTerm/index'
    }
    ,
    {
        path: '/data/correction/employeeresult',
        component: (callback) => {
            import('./../viewport/dataCorrection/employeeResult/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/data/correction/employeeresult'
    }
    ,
    {
        path: '/patrol/class/summary',
        component: (callback) => {
            import('../viewport/patrol/summary/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/patrol/class/summary'
    },
    {
        path: '/patrol/summary/result/:id',
        component: (callback) => {
            import('../viewport/patrol/summary/Result').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/patrol/summary/result/'
    }
    ,
    {
        path: '/datav/config/patrol/eval/index',
        component: (callback) => {
            import('../viewport/dataVConfig/patrolClassEval/dataVConfig').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/datav/config/patrol/eval/index'
    },
    {
        path: '/dataviewdata/index',
        component: (callback) => {
            import('../viewport/dataViewSource/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/dataviewdata/index'
    },
    {
        path: '/reverseeval/index/:targetId',
        component: (callback) => {
            import('../viewport/reversEeval/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/reverseeval/index'
    }
    ,
    {
        path: '/datav/config/smart/tour/index',
        component: (callback) => {
            import('../viewport/dataVConfig/smartTourEval/dataVConfig').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/datav/config/smart/tour/index'
    }
    ,
    {
        path: '/eval/result/analysis/reliability',
        component: (callback) => {
            import('./../viewport/reports/analysis/reliabilityAnalysis/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/analysis/reliability'
    }
    ,
    {
        path: '/eval/result/analysis/validity',
        component: (callback) => {
            import('./../viewport/reports/analysis/validityAnalysis/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/eval/result/analysis/validity'
    }
    ,
    {
        path: '/opening/teacher/summary/:itemId',
        component: (callback) => {
            import('../viewport/openingTeacherSummary/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/opening/teacher/summary/'
    },
    {
        path: '/analysis/multiplecoursetargetanalysis/index',
        component: (callback) => {
            import('../viewport/multipleCoursetargetAnalysis/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/analysis/multiplecoursetargetanalysis/index'
    }
    ,
    {
        path: '/project/folder/index',
        component: (callback) => {
            import('../viewport/project/folder/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/project/folder/index'
    }
    ,
    {
        path: '/project/category/index',
        component: (callback) => {
            import('./../viewport/project/category/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/project/category/index'
    }
    ,
    {
        path: '/project/enter/index',
        component: (callback) => {
            import('../viewport/project/enter/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/project/enter/index'
    }
    ,
    {
        path: '/project/enterByFolder/:id',
        component: (callback) => {
            import('../viewport/project/enter/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/project/enterByFolder/'
    }
    ,
    {
        path: '/project/result/index',
        component: (callback) => {
            import('./../viewport/project/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/project/result/index'
    }
    ,
    {
        path: '/project/resultByFolder/:id',
        component: (callback) => {
            import('./../viewport/project/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/project/resultByFolder'
    }
    ,
    {
        path: '/project/resultEdit/:id',
        component: (callback) => {
            import('./../viewport/project/result/ResultEdit').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/project/resultEdit/'
    }
    ,
    {
        path: '/project/ResultDetail/:id',
        component: (callback) => {
            import('./../viewport/project/result/ResultDetail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/project/ResultDetail/'
    }
    ,

    {
        path: '/project/expert/assign/index',
        component: (callback) => {
            import('./../viewport/project/expert/assign/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/project/expert/assign/index'
    }
    ,

    {
        path: '/project/expert/assignByFolder/:id',
        component: (callback) => {
            import('./../viewport/project/expert/assign/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/project/expert/assignByFolder/'
    }
    ,
    {
        path: '/project/expert/review/index',
        component: (callback) => {
            import('./../viewport/project/expert/review/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/project/expert/review/index'
    }
    ,
    {
        path: '/project/expert/reviewByFolder/:id',
        component: (callback) => {
            import('./../viewport/project/expert/review/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/project/expert/reviewByFolder/'
    }
    ,
    {
        path: '/project/expert/assess/:id',
        component: (callback) => {
            import('./../viewport/project/expert/review/Assess').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/project/expert/assess/'
    }
    ,
    {
        path: '/project/sysParam/index',
        component: (callback) => {
            import('./../viewport/project/sysParam/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/project/sysParam/index'
    }
    ,
    {
        path: '/project/expert/result/index',
        component: (callback) => {
            import('./../viewport/project/expert/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/project/expert/result/index'
    }
    ,
    {
        path: '/project/expert/resultByFolder/:id',
        component: (callback) => {
            import('./../viewport/project/expert/result/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/project/expert/resultByFolder/'
    }
    ,
    {
        path: '/project/expert/total/index',
        component: (callback) => {
            import('./../viewport/project/expert/total/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/project/expert/total/index'
    }
    ,
    {
        path: '/project/expert/totalByFolder/:id',
        component: (callback) => {
            import('./../viewport/project/expert/total/Query').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/project/expert/totalByFolder/'
    }
    ,
    {
        path: '/project/expert/detail/:id',
        component: (callback) => {
            import('./../viewport/project/expert/total/Detail').then((Products) => {
                callback(Products.default);
            });
        },
        name: '/project/expert/detail/'
    },
].map(item => {
    var array = item.path.split(":")
    array[0] = array[0].toLowerCase()
    return {
        path: array.join(":"),
        component: item.component,
        name: item.name
    }
})

export default RouterList;